/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;
/******/
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(1);


/***/ }),
/* 1 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	/// <reference path="gLightbox.d.ts" />
	/// <reference path="userData.d.ts" />
	/// <reference path="config.d.ts" />
	/// <reference path="gImageZoom.d.ts" />
	/// <reference path="gPanels.d.ts" />
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
	    return new (P || (P = Promise))(function (resolve, reject) {
	        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
	        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
	        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
	        step((generator = generator.apply(thisArg, _arguments || [])).next());
	    });
	};
	var __generator = (this && this.__generator) || function (thisArg, body) {
	    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
	    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
	    function verb(n) { return function (v) { return step([n, v]); }; }
	    function step(op) {
	        if (f) throw new TypeError("Generator is already executing.");
	        while (_) try {
	            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
	            if (y = 0, t) op = [op[0] & 2, t.value];
	            switch (op[0]) {
	                case 0: case 1: t = op; break;
	                case 4: _.label++; return { value: op[1], done: false };
	                case 5: _.label++; y = op[1]; op = [0]; continue;
	                case 7: op = _.ops.pop(); _.trys.pop(); continue;
	                default:
	                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
	                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
	                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
	                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
	                    if (t[2]) _.ops.pop();
	                    _.trys.pop(); continue;
	            }
	            op = body.call(thisArg, _);
	        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
	        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
	    }
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	__webpack_require__(2);
	// Mock up for najax library
	var core_decorators_1 = __webpack_require__(11);
	var config_1 = __webpack_require__(30);
	var $ = window.jQuery;
	// Detect which OS the user is accessing from
	var userAgent = navigator.userAgent.toLowerCase();
	var windowsPhone = userAgent.indexOf('windows phone') > -1;
	var androidMobile = (userAgent.indexOf('android') > -1 && userAgent.indexOf('mobile') > -1) && !windowsPhone;
	var androidTablet = (userAgent.indexOf('android') > -1 && userAgent.indexOf('mobile') === -1) && !windowsPhone;
	var iPhone = (userAgent.indexOf('iphone') > -1 || userAgent.indexOf('ipod') > -1) && !windowsPhone;
	var iPad = userAgent.indexOf('ipad') > -1 && !windowsPhone;
	// Setup basic configurations for the lightbox
	var isTouchOS = (windowsPhone || androidMobile || androidTablet || iPhone || iPad);
	var isOpen = false;
	// Internal userId -> userName cache
	var userCache = {};
	/**
	 * Creates a lightbox that overlaps the entire visible page, giving the user the
	 * impression that he's now fully entered the contents embedded in the lightbox.
	 */
	var gLightbox = /** @class */ (function () {
	    /**
	     * Cache options and render the lightbox when a new instance is created.
	     */
	    function gLightbox(options, index) {
	        // If a lightbox is already open, then abort
	        if (isOpen) {
	            // Warn developers of the issue
	            console.error('new gLightbox(...): ' +
	                'Another lightbox is already open!');
	            // Abort further execution
	            return;
	        }
	        // Register that a lightbox is now open!
	        isOpen = true;
	        // Block scrolling on the body-layer!
	        this.originalScroll = ((document.documentElement.getAttribute('css') || '').replace(/\s/g, '').split('overflow:')[1] || '').split(';')[0];
	        document.documentElement.style.overflow = 'hidden';
	        // Convert into array of options to support syntax that contains
	        // multiple pages inside the lightbox
	        this.options = Array.isArray(options) ? options : [options];
	        this.index = index || 0;
	        // Prepare internal cache-objects
	        this.containers = new Array(this.options.length);
	        this.contents = new Array(this.options.length);
	        this.clickListeners = [];
	        this.activities = {};
	        this.favorites = {};
	        // Create a wrapper-component that can contain the contents of the
	        // lightbox
	        this.wrapper = document.createElement('div');
	        this.wrapper.className = 'gLightbox gLightbox-interface-' + (isTouchOS ? 'touch' : 'mouse');
	        // Inject the first page into the wrapper
	        this.wrapper.appendChild(this.renderContainer(this.index));
	        // Inject the lightbox into the DOM
	        document.body.appendChild(this.wrapper);
	        // Auto-close the lightbox when the user presses escape
	        window.addEventListener('keyup', this.onKeyPress, true);
	    }
	    /** Helper that specifies if a lightbox is currently open */
	    gLightbox.isOpen = function () {
	        return !!isOpen;
	    };
	    /**
	     * Render the contents of an embedded element in the lightbox (this is
	     * essentially the templating of the lightbox).
	     */
	    gLightbox.prototype.renderContainer = function (index) {
	        var _this = this;
	        // If the contents have not been rendered and cached yet, then do it now
	        if (!this.contents[index]) {
	            // Fetch options for rendering the page
	            var options_1 = this.options[index];
	            // Create an element that can contain the contents
	            var contents = document.createElement('div');
	            // Apply CSS-styling
	            contents.className = 'gLightbox-wrapper';
	            // Render the HTML inside the lightbox
	            contents.innerHTML = "\n                <header class=\"gLightbox-header\">\n                    <h1 class=\"gLightbox-header-title\">" + options_1.title + "</h1>\n                    <span class=\"gLightbox-header-due\" style=\"display: none;\">\n                        <i class=\"gLightbox-icon gLightbox-icon-calendar\"></i>\n                        <span class=\"gLightbox-header-due-date\"></span>\n                    </span>\n\n                    <nav class=\"gLightbox-header-nav\">\n                        <a class=\"gLightbox-header-nav-prev gLightbox-icon gLightbox-icon-nav\"></a>\n                        " + (index + 1) + " af " + this.options.length + "\n                        <a class=\"gLightbox-header-nav-next gLightbox-icon gLightbox-icon-nav\"></a>\n                    </nav>\n\n                    <a class=\"gLightbox-header-btn gLightbox-icon gLightbox-icon-notebook\"></a>\n                    <a class=\"gLightbox-header-btn gLightbox-header-btn-throbber gLightbox-header-btn-spin gLightbox-icon gLightbox-icon-star\" style=\"display: none;\"><span class=\"gLightbox-header-btn-checkmarkContainer gLightbox-icon-checkmark\"></span></a>\n                    <a class=\"gLightbox-header-btn gLightbox-header-btn-throbber gLightbox-header-btn-spin gLightbox-icon gLightbox-icon-checkmark\" style=\"display: none;\"></a>\n                    <a class=\"gLightbox-header-btn gLightbox-icon gLightbox-icon-close\"></a>\n                </header>\n\n                <section class=\"gLightbox-contents\">\n                </section>\n            ";
	            // Create references to nested nodes
	            var header_1 = contents.getElementsByClassName('gLightbox-header')[0];
	            var title_1 = contents.getElementsByClassName('gLightbox-header-title')[0];
	            var dueDate_1 = contents.getElementsByClassName('gLightbox-header-due')[0];
	            var dueDateLabel_1 = contents.getElementsByClassName('gLightbox-header-due-date')[0];
	            var nav = contents.getElementsByClassName('gLightbox-header-nav')[0];
	            var navPrev = contents.getElementsByClassName('gLightbox-header-nav-prev')[0];
	            var navNext = contents.getElementsByClassName('gLightbox-header-nav-next')[0];
	            var btnNotebook = contents.getElementsByClassName('gLightbox-icon-notebook')[0];
	            var btnFavorite_1 = contents.getElementsByClassName('gLightbox-icon-star')[0];
	            var btnSubmit_1 = contents.getElementsByClassName('gLightbox-icon-checkmark')[1];
	            var btnClose = contents.getElementsByClassName('gLightbox-icon-close')[0];
	            var container_1 = contents.getElementsByClassName('gLightbox-contents')[0];
	            // Determine if this is an entry not owned by the currently signed
	            // in user
	            var isEntry = (options_1.content.type === "componentEntry" || options_1.content.type === "taskResult");
	            var isSharedEntry = ((options_1.content.type === "componentEntry" || options_1.content.type === "taskResult") &&
	                (options_1.content.userId && options_1.content.userId !== config_1.default.userId));
	            // Hide the title-element altogether, if there is no content in it
	            if (!options_1.title && !isSharedEntry) {
	                title_1.parentNode.removeChild(title_1);
	            }
	            // Inject username into the title (if opening an entry that's not
	            // owned by the currently signed in user)
	            if (isSharedEntry) {
	                var entryData_1 = options_1.content;
	                // Load name from cache?
	                if (userCache[entryData_1.userId]) {
	                    title_1.innerHTML = options_1.title ? options_1.title + ' | ' + userCache[entryData_1.userId] : userCache[entryData_1.userId];
	                    // ... Otherwise fetch name now!
	                }
	                else {
	                    // Indicate that we're loading user-name
	                    title_1.innerHTML = options_1.title ? options_1.title + ' | ...' : '...';
	                    // Determine whether to load data about an eKey- or a UniC-user
	                    var api = '';
	                    if (!String(entryData_1.userId).match(/[^\@]+\@[^\.]+\..+/)) {
	                        api = config_1.default.API.unicUser;
	                    }
	                    else {
	                        api = config_1.default.API.ekeyUser;
	                    }
	                    // Load data from the endpoint
	                    gLightbox.ajax({
	                        url: api.replace('%userId%', entryData_1.userId)
	                    }).then(function (response) {
	                        try {
	                            if (typeof response === 'string') {
	                                response = JSON.parse(response);
	                            }
	                            // Inject user-name into the lightbox
	                            title_1.innerHTML = options_1.title ? options_1.title + ' | ' + response.Name : response.Name;
	                            // Cache response
	                            userCache[entryData_1.userId] = response.Name;
	                        }
	                        catch (err) {
	                            // Ignore errors...
	                        }
	                    }, function () {
	                        // No specific error handling, simply not displaying
	                        // username in the title...
	                        // Function is added to prevent errors from being
	                        // reported to the console!
	                    });
	                }
	            }
	            // Detect if there are multiple embeds in the lightbox
	            if (this.options.length > 1) {
	                // Bind helper-methods to navigate to the next/previous slides, when
	                // the user clicks the buttons
	                this.attachClickListener(navPrev, this.goTo.bind(this, index - 1));
	                this.attachClickListener(navNext, this.goTo.bind(this, index + 1));
	                // Disable if required
	                if (index === 0) {
	                    navPrev.classList.add('gLightbox-header-nav-disabled');
	                }
	                if (index === this.options.length - 1) {
	                    navNext.classList.add('gLightbox-header-nav-disabled');
	                }
	                // Update header-state
	                header_1.classList.add('gLightbox-header-hasNav');
	                // ... Otherwise hide the navigation-bar
	            }
	            else {
	                nav.parentNode.removeChild(nav);
	            }
	            // Determine whether to add a activity-features to the contents
	            if (options_1.activityId) {
	                btnSubmit_1.id = 'gLightbox-header-btn-activity-' + options_1.activityId;
	                // Load activity-status
	                this.loadActivity(options_1.activityId).then(function (activity) {
	                    // Remove the throbber
	                    btnSubmit_1.classList.remove('gLightbox-header-btn-throbber');
	                    setTimeout(function () {
	                        btnSubmit_1.classList.remove('gLightbox-header-btn-spin');
	                    }, 125);
	                    // Bind callback to submit the activity
	                    _this.attachClickListener(btnSubmit_1, _this.submitActivity.bind(_this, {
	                        id: options_1.activityId
	                    }));
	                    // If the activity is already submitted, then update button
	                    // status
	                    if (activity.submitted) {
	                        dueDate_1.classList.add('gLightbox-header-due-ok');
	                        btnSubmit_1.classList.add('gLightbox-icon-checkmark-ok');
	                    }
	                    // If a due-data is defined, then inject it into the DOM
	                    if (activity.due) {
	                        // Parse the date
	                        var due = new Date(activity.due * 1000);
	                        // Prepare actual date-fragments
	                        var date = due.getDate() >= 10 ? due.getDate() : '0' + due.getDate();
	                        var month = due.getMonth() >= 9 ? (due.getMonth() + 1) : '0' + (due.getMonth() + 1);
	                        var year = due.getFullYear() >= 10 ? due.getFullYear() : '0' + due.getFullYear();
	                        // Render the due-date!
	                        dueDateLabel_1.innerHTML = date + "-" + month + "-" + year;
	                        dueDate_1.classList.add('gLightbox-header-due-visible');
	                        // Update header-state
	                        header_1.classList.add('gLightbox-header-hasDueDate');
	                        // Highlight if the due-date has been surpassed and the
	                        // activity has not been submitted yet
	                        if (activity.due < Date.now() / 1000 && !activity.submitted) {
	                            dueDate_1.classList.add('gLightbox-header-due-overdue');
	                        }
	                    }
	                }, function () { });
	                // ... Otherwise hide the button and due-date
	            }
	            else {
	                btnSubmit_1.parentNode.removeChild(btnSubmit_1);
	                dueDate_1.parentNode.removeChild(dueDate_1);
	            }
	            // Determine whether or not to add favorite-features to the lightbox
	            if (options_1.productId && options_1.learningObject) {
	                btnFavorite_1.id = 'gLightbox-header-btn-favorite-' + options_1.learningObject.id;
	                // Load current status for the learning-object initially
	                this.checkFavorite(options_1.learningObject).then(function (isFavorite) {
	                    // Remove the throbber
	                    btnFavorite_1.classList.remove('gLightbox-header-btn-throbber');
	                    setTimeout(function () {
	                        btnFavorite_1.classList.remove('gLightbox-header-btn-spin');
	                    }, 125);
	                    // Bind an event-listener to toggle status on/off
	                    _this.attachClickListener(btnFavorite_1, _this.toggleFavorite.bind(_this, {
	                        productId: options_1.productId,
	                        learningObject: options_1.learningObject
	                    }));
	                    if (isFavorite) {
	                        btnFavorite_1.classList.add('gLightbox-icon-favorite-on');
	                    }
	                }, function () { });
	                // ... Otherwise hide the button
	            }
	            else {
	                btnFavorite_1.parentNode.removeChild(btnFavorite_1);
	            }
	            // Determine if notebook should be enabled
	            if ((options_1.content.type === "componentEntry" || options_1.content.type === "taskResult") &&
	                (options_1.productId && options_1.content.userId === config_1.default.userId)) {
	                // If the gPanels have been loaded, then open the notepanel on
	                // click on the button instead of opening the notebook in a new
	                // window
	                if ($ && $(btnNotebook).gPanels) {
	                    $(btnNotebook).gPanels({
	                        type: 'notes',
	                        iconType: 'none',
	                        productId: options_1.productId,
	                        learningObject: options_1.learningObject
	                    });
	                }
	                else {
	                    this.attachClickListener(btnNotebook, this.openNotebook.bind(this));
	                }
	                // ... Otherwise hide the button
	            }
	            else {
	                btnNotebook.parentNode.removeChild(btnNotebook);
	            }
	            // Bind function to handle closing the lightbox
	            this.attachClickListener(btnClose, this.close.bind(this));
	            // Render the contents inside the lightbox
	            var startedAt_1 = Date.now();
	            var duration_1 = 625;
	            switch (options_1.content.type) {
	                case 'iframe':
	                case 'component':
	                case 'componentEntry':
	                case 'taskResult':
	                    // Create an iframe that contain the desired contents
	                    var iframe_1 = document.createElement('iframe');
	                    // Configure iFrame
	                    iframe_1.id = 'gLightbox-iframe-' + index;
	                    iframe_1.setAttribute('allowFullscreen', 'true');
	                    iframe_1.setAttribute('allowTransparency', 'true');
	                    iframe_1.setAttribute('frameborder', '0');
	                    // Apply CSS
	                    iframe_1.className = 'gLightbox-contents-iframe';
	                    // Load contents if URL is available
	                    if (options_1.content.type === 'iframe') {
	                        // Wait for the iframe to load before being rendered
	                        iframe_1.onload = function () {
	                            container_1.classList.add('gLightbox-contents-loaded');
	                            iframe_1.onload = null;
	                        };
	                        // Source must be given as an absolute string
	                        if (typeof options_1.content.src === 'string') {
	                            iframe_1.src = options_1.content.src;
	                        }
	                        else {
	                            throw new TypeError('gLightbox.renderContainer(...): content.src must be given as a string when content.type is "iframe"!');
	                        }
	                        // ... Otherwise load required data to auto-generate the
	                        // URL
	                    }
	                    else {
	                        switch (options_1.content.type) {
	                            case 'component':
	                                // Prepare the URL that we need to forward the user to
	                                var url = config_1.default.API.componentProxy + "ComponentViewer";
	                                // Add authentication info to the URL
	                                url += '?userID=' + encodeURIComponent(config_1.default.userId);
	                                url += '&componentID=' + encodeURIComponent(options_1.content.componentId);
	                                url += '&componentType=' + encodeURIComponent(options_1.content.componentType);
	                                if (options_1.learningObject) {
	                                    url += '&learningObjectId=' + encodeURIComponent(options_1.learningObject.id);
	                                    url += '&learningObjectTitle=' + encodeURIComponent(options_1.learningObject.title);
	                                }
	                                else {
	                                    console.warn("gLightbox: Attempting to open a component without specifying learningObject. While this will work, it is strongly discouraged as it will not integrate well with AktivitetsCenter.");
	                                }
	                                // Wait for the iframe to load before being rendered
	                                iframe_1.onload = function () {
	                                    container_1.classList.add('gLightbox-contents-loaded');
	                                    iframe_1.onload = null;
	                                };
	                                // Open the component in the iframe
	                                iframe_1.src = window.gProxy.forwardTo(url);
	                            case 'componentEntry':
	                                var content_1 = options_1.content;
	                                // Fetch data about the component
	                                gLightbox.ajax({ url: config_1.default.API.componentEntry.replace('%entryId%', content_1.entryId) }).then(function (response) {
	                                    if (typeof response === 'string') {
	                                        response = JSON.parse(response);
	                                    }
	                                    // Make sure everything went OK
	                                    if (!response.error) {
	                                        // Prepare the URL that we need to forward the user to
	                                        var url_1 = config_1.default.API.componentProxy;
	                                        if (config_1.default.userId === response.userID) {
	                                            url_1 += 'ComponentViewer';
	                                        }
	                                        else {
	                                            url_1 += 'ComponentEntry';
	                                        }
	                                        // Add authentication info to the URL
	                                        url_1 += '?userID=' + encodeURIComponent(config_1.default.userId);
	                                        url_1 += '&componentID=' + encodeURIComponent(response.componentID);
	                                        url_1 += '&componentEntryID=' + encodeURIComponent(response.objectID);
	                                        url_1 += '&componentType=' + encodeURIComponent(response.componentType);
	                                        if (options_1.learningObject) {
	                                            url_1 += '&learningObjectId=' + encodeURIComponent(options_1.learningObject.id);
	                                            url_1 += '&learningObjectTitle=' + encodeURIComponent(options_1.learningObject.title);
	                                        }
	                                        else {
	                                            console.warn("gLightbox: Attempting to open a component without specifying learningObject. While this will work, it is strongly discouraged as it will not integrate well with AktivitetsCenter.");
	                                        }
	                                        // Wait for the iframe to load before being rendered
	                                        iframe_1.onload = function () {
	                                            container_1.classList.add('gLightbox-contents-loaded');
	                                            iframe_1.onload = null;
	                                        };
	                                        // Open the component in the iframe
	                                        iframe_1.src = window.gProxy.forwardTo(url_1);
	                                        // ... Otherwise close the window and notify the user
	                                    }
	                                    else {
	                                        // We need to create a custom error-message that prompts the user that the
	                                        // result could not be opened!
	                                        _this.showMessage(container_1, 'Der opstod en fejl under viderestilling, vi beklager...');
	                                        // Kill the iframe
	                                        iframe_1.style.display = 'none';
	                                    }
	                                }, function () {
	                                    // Show message if data about the entry couldn't be fetched
	                                    _this.showMessage(container_1, 'Der opstod en fejl under viderestilling, vi beklager...');
	                                    // Kill the iframe
	                                    iframe_1.style.display = 'none';
	                                });
	                                break;
	                            case 'taskResult':
	                                // Fetch data about the component
	                                gLightbox.ajax({ url: config_1.default.API.taskResult.replace('%entryId%', options_1.content.entryId) }).then(function (response) {
	                                    if (typeof response === 'string') {
	                                        response = JSON.parse(response);
	                                    }
	                                    // Make sure everything went OK
	                                    if (!response.error) {
	                                        // Prepare the URL that we need to forward the user to
	                                        var url_2 = config_1.default.API.taskPlayer;
	                                        // Now add authentication to the request
	                                        url_2 += '?taskPlayerId=' + encodeURIComponent(response.taskPlayerID);
	                                        url_2 += '&userName=' + encodeURIComponent(config_1.default.userId);
	                                        url_2 += '&productID=' + encodeURIComponent(response.productID);
	                                        url_2 += '&title=' + encodeURIComponent(response.title);
	                                        url_2 += '&resultID=' + encodeURIComponent(response.objectID);
	                                        // Wait for the iframe to load before being rendered
	                                        iframe_1.onload = function () {
	                                            container_1.classList.add('gLightbox-contents-loaded');
	                                            iframe_1.onload = null;
	                                        };
	                                        // Open the taskplayer in the popup-window
	                                        iframe_1.src = url_2;
	                                        // ... Otherwise close the window and notify the user
	                                    }
	                                    else {
	                                        // Show message if data about the entry couldn't be fetched
	                                        _this.showMessage(container_1, 'Der opstod en fejl under viderestilling, vi beklager...');
	                                        // Kill the iframe
	                                        iframe_1.style.display = 'none';
	                                    }
	                                }, function () {
	                                    // Show message if data about the entry couldn't be fetched
	                                    _this.showMessage(container_1, 'Der opstod en fejl under viderestilling, vi beklager...');
	                                    // Kill the iframe
	                                    iframe_1.style.display = 'none';
	                                });
	                                break;
	                            default:
	                            // ... No other cases will ever land here
	                        }
	                    }
	                    // Inject into the DOM
	                    setTimeout(function () {
	                        container_1.appendChild(iframe_1);
	                    }, duration_1);
	                    this.contents[index] = iframe_1;
	                    break;
	                case 'image':
	                    // Render images without zoom-plugin?
	                    if (!window.gImageZoom) {
	                        // Render the wrapper for the image
	                        container_1.innerHTML = '<div class="gLightbox-contents-image"></div>';
	                        // Create an iframe that contain the desired contents
	                        var wrapper = container_1.getElementsByClassName('gLightbox-contents-image')[0];
	                        var img_1 = new Image();
	                        // Wait for the iframe to load before being rendered
	                        img_1.onload = img_1.onerror = img_1.onabort = function () {
	                            setTimeout(function () {
	                                container_1.classList.add('gLightbox-contents-loaded');
	                            }, Math.max(0, duration_1 - (Date.now() - startedAt_1)));
	                            img_1.onload = img_1.onerror = img_1.onabort = null;
	                        };
	                        // Apply CSS
	                        img_1.className = 'gLightbox-contents-image-img';
	                        // Source must be given as an absolute string
	                        if (typeof options_1.content.src === 'string') {
	                            img_1.src = options_1.content.src;
	                        }
	                        else {
	                            throw new TypeError('gLightbox.renderContainer(...): content.src must be given as a string when content.type is "image" and gImageZoom is not available!');
	                        }
	                        // Inject into the DOM
	                        wrapper.appendChild(img_1);
	                        container_1.appendChild(wrapper);
	                        this.contents[index] = wrapper;
	                        // ... Or embed into the gImageZoom component?
	                    }
	                    else {
	                        var content_2 = options_1.content;
	                        // Render the wrapper for the zoom-plugin
	                        container_1.innerHTML = '<div class="gLightbox-contents-image"></div>';
	                        // Create a reference to the wrapper
	                        var wrapper_1 = container_1.getElementsByClassName('gLightbox-contents-image')[0];
	                        // Initialize the gImageZoom-component!
	                        setTimeout(function () {
	                            container_1.classList.add('gLightbox-contents-loaded');
	                            setTimeout(function () {
	                                new window.gImageZoom({
	                                    node: wrapper_1,
	                                    src: content_2.src,
	                                    text: content_2.caption,
	                                });
	                            });
	                        }, 500);
	                        this.contents[index] = wrapper_1;
	                    }
	                    break;
	                default:
	                    var content = options_1.content;
	                    console.error("gLightbox.renderContainer(...): " +
	                        ("The type \"" + content.type + "\" is not supported."));
	                    break;
	            }
	            // Cache the page
	            this.containers[index] = contents;
	        }
	        // Return the wrapped contents
	        return this.containers[index];
	    };
	    /** Helper-method that applies the given listener to the click-event */
	    gLightbox.prototype.attachClickListener = function (elem, listener) {
	        // Add the event-listener
	        elem.addEventListener(isTouchOS ? 'touchend' : 'click', listener, false);
	        // Cache callback
	        this.clickListeners.push({ elem: elem, listener: listener });
	    };
	    /**
	     * Renders a message inside the container, which is useful if an error
	     * occurs while trying to download the contents.
	     */
	    gLightbox.prototype.showMessage = function (container, message) {
	        // Create DOM-elements
	        var wrapper = document.createElement('div');
	        var label = document.createElement('span');
	        wrapper.appendChild(label);
	        // Apply styling
	        wrapper.className = 'gLightbox-contents-message';
	        label.className = 'gLightbox-contents-message-label';
	        // Inject message
	        label.innerHTML = message;
	        // Inject into the wrapper
	        container.appendChild(wrapper);
	        // Make sure that the message is displayed
	        container.classList.add('gLightbox-contents-loaded');
	    };
	    /**
	     * Navigates to the specified index of available content pages in the
	     * lightbox.
	     */
	    gLightbox.prototype.goTo = function (index) {
	        var _this = this;
	        index = Math.max(0, Math.min(this.options.length - 1, index));
	        // Skip if we're already at this index
	        if (this.index === index || this.transitioning) {
	            return;
	        }
	        this.transitioning = true;
	        // Prepare leave for the currently rendered page
	        var oldContainer = this.containers[this.index];
	        var oldContents = this.contents[this.index];
	        var newContainer = this.renderContainer(index);
	        var newContents = this.contents[index];
	        // Reset current animations
	        oldContainer.classList.remove('gLightbox-wrapper-transition-in-left');
	        oldContainer.classList.remove('gLightbox-wrapper-transition-in-right');
	        oldContainer.classList.remove('gLightbox-wrapper-transition-out-left');
	        oldContainer.classList.remove('gLightbox-wrapper-transition-out-right');
	        newContainer.classList.remove('gLightbox-wrapper-transition-in-left');
	        newContainer.classList.remove('gLightbox-wrapper-transition-in-right');
	        newContainer.classList.remove('gLightbox-wrapper-transition-out-left');
	        newContainer.classList.remove('gLightbox-wrapper-transition-out-right');
	        // Slide left or right?
	        if (index > this.index) {
	            oldContainer.classList.add('gLightbox-wrapper-transition-out-left');
	            newContainer.classList.add('gLightbox-wrapper-transition-in-left');
	        }
	        else {
	            oldContainer.classList.add('gLightbox-wrapper-transition-out-right');
	            newContainer.classList.add('gLightbox-wrapper-transition-in-right');
	        }
	        // If rendering an iframe, then remove it temporarily while we're
	        // transitioning to prevent framerate-drop!
	        var handleIframe = (newContents.tagName.toLowerCase() === 'iframe' &&
	            newContents.parentNode);
	        if (handleIframe) {
	            newContents.parentNode.classList.remove('gLightbox-contents-loaded');
	            newContents.parentNode.removeChild(newContents);
	        }
	        this.wrapper.appendChild(newContainer);
	        // Remove the old child after the animation has finished
	        setTimeout(function () {
	            // Remove the old container from the DOM
	            oldContainer.parentNode.removeChild(oldContainer);
	            // Re-inject iframes into the lightbox, and wait for it to load
	            if (handleIframe) {
	                // Wait for the frame to load before removing the throbber
	                newContents.onload = function () {
	                    // Remove the throbber
	                    newContainer.getElementsByClassName('gLightbox-contents')[0].classList.add('gLightbox-contents-loaded');
	                    // Clear event-callback!
	                    newContents.onload = null;
	                };
	                // Reload iframe
	                newContainer.getElementsByClassName('gLightbox-contents')[0].appendChild(newContents);
	            }
	            // Register that transitioning has finished
	            _this.transitioning = false;
	        }, 625);
	        // Update current index
	        this.index = index;
	    };
	    /** Auto-close the lightbox if the user clicks escape */
	    gLightbox.prototype.onKeyPress = function (evt) {
	        // Close if the user presses escape
	        if (evt.keyCode === 27) {
	            this.close();
	        }
	        // Navigate prev/next if the user uses the arrows
	        if (evt.keyCode === 39) {
	            this.goTo(this.index + 1);
	        }
	        else if (evt.keyCode === 37) {
	            this.goTo(this.index - 1);
	        }
	        // Stop event propagation
	        if (evt.stopPropagation) {
	            evt.stopPropagation();
	        }
	        evt.cancelBubble = true;
	    };
	    /** Closes the lightbox and completely cleans up memory after it */
	    gLightbox.prototype.close = function () {
	        var _this = this;
	        // Prevent accidentally triggering the closing-mechanism twice
	        if (this.isClosed) {
	            return;
	        }
	        this.isClosed = true;
	        // Run the close-animation
	        this.wrapper.classList.add('gLightbox-closing');
	        // Unbind all associated event-listeners
	        this.clickListeners.forEach(function (click) {
	            click.elem.removeEventListener(isTouchOS ? 'touchend' : 'click', click.listener, false);
	        });
	        // Clean up memory
	        this.options = null;
	        this.containers = null;
	        this.contents = null;
	        this.activities = null;
	        this.favorites = null;
	        this.clickListeners = null;
	        // Wait for the animation to finish, then remove the lightbox from the
	        // DOM
	        setTimeout(function () {
	            _this.wrapper.parentNode.removeChild(_this.wrapper);
	            _this.wrapper = null;
	            // Re-allow scrolling
	            document.documentElement.style.overflow = _this.originalScroll;
	            // Register that the lightbox was closed
	            isOpen = false;
	        }, 625);
	        // Unbind event-listeners
	        window.removeEventListener('keyup', this.onKeyPress, true);
	    };
	    /** Helper-method that loads activity data from the UserData API */
	    gLightbox.prototype.loadActivity = function (id) {
	        return __awaiter(this, void 0, void 0, function () {
	            var startedAt, minDuration, activity;
	            return __generator(this, function (_a) {
	                switch (_a.label) {
	                    case 0:
	                        // If this activity has already been loaded, then return the internally
	                        // cached data!
	                        if (this.activities[id]) {
	                            return [2 /*return*/, this.activities[id]];
	                        }
	                        startedAt = Date.now();
	                        minDuration = 650;
	                        return [4 /*yield*/, new Promise(function (resolve) {
	                                setTimeout(resolve, Math.random() * 2000);
	                            })];
	                    case 1:
	                        _a.sent();
	                        activity = {
	                            id: id,
	                            due: Math.round(Date.now() / 1000 + (Math.random() - 0.5) * 5184000),
	                            submitted: Math.random() >= 0.5
	                        };
	                        // Cache it internally
	                        this.activities[id] = activity;
	                        // Wait the minimum duration before updating the UI
	                        return [4 /*yield*/, new Promise(function (resolve) {
	                                setTimeout(resolve, Math.max(0, minDuration - (Date.now() - startedAt)));
	                            })];
	                    case 2:
	                        // Wait the minimum duration before updating the UI
	                        _a.sent();
	                        // Return data
	                        return [2 /*return*/, activity];
	                }
	            });
	        });
	    };
	    /** Helper-method that submits an activity using the UserData API */
	    gLightbox.prototype.submitActivity = function (_a) {
	        var id = _a.id, _b = _a.allowRetry, allowRetry = _b === void 0 ? true : _b;
	        return __awaiter(this, void 0, void 0, function () {
	            var startedAt, minDuration, btn, due, err_1;
	            var _this = this;
	            return __generator(this, function (_c) {
	                switch (_c.label) {
	                    case 0:
	                        // Abort, if already submitted
	                        if (this.activities[id].submitted) {
	                            return [2 /*return*/, true];
	                        }
	                        startedAt = Date.now();
	                        minDuration = 500 + Math.round(200 * Math.random());
	                        btn = document.getElementById('gLightbox-header-btn-activity-' + id);
	                        due = btn.parentNode.getElementsByClassName('gLightbox-header-due')[0];
	                        // Show throbber while submitting
	                        btn.classList.add('gLightbox-header-btn-throbber');
	                        btn.classList.add('gLightbox-header-btn-spin');
	                        _c.label = 1;
	                    case 1:
	                        _c.trys.push([1, 3, , 4]);
	                        return [4 /*yield*/, new Promise(function (resolve) {
	                                setTimeout(resolve, Math.random() * 1000);
	                            })];
	                    case 2:
	                        _c.sent();
	                        // Handle errors?
	                        if (Math.random() >= 0.5) {
	                            throw new Error('fail');
	                        }
	                        return [3 /*break*/, 4];
	                    case 3:
	                        err_1 = _c.sent();
	                        // Retry request?
	                        if (allowRetry) {
	                            setTimeout(function () {
	                                _this.submitActivity({ id: id, allowRetry: false });
	                            }, Math.round((Math.random() + 0.5) * 500));
	                            return [2 /*return*/, false];
	                        }
	                        // Alert the user
	                        alert("Der opstod en fejl, da vi fors\u00F8gte at aflevere aktiviteten til din l\u00E6rer.");
	                        // Hide the throbber
	                        btn.classList.remove('gLightbox-header-btn-throbber');
	                        setTimeout(function () {
	                            btn.classList.remove('gLightbox-header-btn-spin');
	                        }, 125);
	                        return [2 /*return*/, false];
	                    case 4:
	                        // Update status
	                        this.activities[id].submitted = true;
	                        // Wait the minimum duration before updating the UI
	                        return [4 /*yield*/, new Promise(function (resolve) {
	                                setTimeout(resolve, Math.max(0, minDuration - (Date.now() - startedAt)));
	                            })];
	                    case 5:
	                        // Wait the minimum duration before updating the UI
	                        _c.sent();
	                        // Update button-status
	                        btn.classList.add('gLightbox-icon-checkmark-ok');
	                        due.classList.add('gLightbox-header-due-ok');
	                        due.classList.remove('gLightbox-header-due-overdue');
	                        // Hide throbber again
	                        btn.classList.remove('gLightbox-header-btn-throbber');
	                        setTimeout(function () {
	                            btn.classList.remove('gLightbox-header-btn-spin');
	                        }, 125);
	                        // Assume that the activity was submitted, otherwise return an error
	                        return [2 /*return*/, true];
	                }
	            });
	        });
	    };
	    /**
	     * Helper-method that determines if a learning-object is currently marked
	     * as a favorite by the user.
	     */
	    gLightbox.prototype.checkFavorite = function (learningObject) {
	        return __awaiter(this, void 0, void 0, function () {
	            var isFavorite, ignore_1;
	            return __generator(this, function (_a) {
	                switch (_a.label) {
	                    case 0:
	                        // If this learningObject status has already been loaded, then return
	                        // the internally cached data!
	                        if (this.favorites[learningObject.id]) {
	                            return [2 /*return*/, this.favorites[learningObject.id]];
	                        }
	                        isFavorite = false;
	                        _a.label = 1;
	                    case 1:
	                        _a.trys.push([1, 3, , 4]);
	                        return [4 /*yield*/, gLightbox.ajax({
	                                url: config_1.default.API.checkFavorite.replace('%id%', encodeURIComponent(learningObject.id))
	                            })];
	                    case 2:
	                        _a.sent();
	                        // If the object was found, then mark as favorite
	                        isFavorite = true;
	                        return [3 /*break*/, 4];
	                    case 3:
	                        ignore_1 = _a.sent();
	                        return [3 /*break*/, 4];
	                    case 4:
	                        // Cache favorite-status internally
	                        this.favorites[learningObject.id] = isFavorite;
	                        // Return result
	                        return [2 /*return*/, this.favorites[learningObject.id]];
	                }
	            });
	        });
	    };
	    /** Helper-method that toggles favorite-status on/off */
	    gLightbox.prototype.toggleFavorite = function (_a) {
	        var productId = _a.productId, learningObject = _a.learningObject, _b = _a.allowRetry, allowRetry = _b === void 0 ? true : _b;
	        return __awaiter(this, void 0, void 0, function () {
	            var startedAt, minDuration, btn, err_2, err_3;
	            var _this = this;
	            return __generator(this, function (_c) {
	                switch (_c.label) {
	                    case 0:
	                        startedAt = Date.now();
	                        minDuration = 500 + Math.round(200 * Math.random());
	                        btn = document.getElementById('gLightbox-header-btn-favorite-' + learningObject.id);
	                        // Abort if we're already working!
	                        if (allowRetry && (btn.classList.contains('gLightbox-header-btn-throbber') || btn.classList.contains('gLightbox-header-btn-checkmark'))) {
	                            return [2 /*return*/, false];
	                        }
	                        // Show throbber while submitting
	                        btn.classList.add('gLightbox-header-btn-throbber');
	                        btn.classList.add('gLightbox-header-btn-spin');
	                        if (!!this.favorites[learningObject.id]) return [3 /*break*/, 5];
	                        _c.label = 1;
	                    case 1:
	                        _c.trys.push([1, 3, , 4]);
	                        return [4 /*yield*/, gLightbox.ajax({
	                                url: config_1.default.API.addFavorite,
	                                headers: {
	                                    'Content-Type': 'application/json'
	                                },
	                                data: JSON.stringify({
	                                    userId: config_1.default.userId,
	                                    productId: productId,
	                                    learningObject: learningObject
	                                })
	                            })];
	                    case 2:
	                        _c.sent();
	                        return [3 /*break*/, 4];
	                    case 3:
	                        err_2 = _c.sent();
	                        // Retry request?
	                        if (allowRetry) {
	                            setTimeout(function () {
	                                _this.toggleFavorite({ productId: productId, learningObject: learningObject, allowRetry: false });
	                            }, Math.round((Math.random() + 0.5) * 500));
	                            return [2 /*return*/, false];
	                        }
	                        // Alert the user
	                        alert("Der opstod en fejl, da vi fors\u00F8gte at tilf\u00F8je \"" + learningObject.title + "\" til dine favoritter.");
	                        // Hide the throbber
	                        btn.classList.remove('gLightbox-header-btn-throbber');
	                        setTimeout(function () {
	                            btn.classList.remove('gLightbox-header-btn-spin');
	                        }, 125);
	                        return [2 /*return*/, false];
	                    case 4: return [3 /*break*/, 8];
	                    case 5:
	                        _c.trys.push([5, 7, , 8]);
	                        return [4 /*yield*/, gLightbox.ajax({
	                                url: config_1.default.API.removeFavorite.replace('%id%', encodeURIComponent(learningObject.id)),
	                                method: 'DELETE'
	                            })];
	                    case 6:
	                        _c.sent();
	                        return [3 /*break*/, 8];
	                    case 7:
	                        err_3 = _c.sent();
	                        // Retry request?
	                        if (allowRetry) {
	                            setTimeout(function () {
	                                _this.toggleFavorite({ productId: productId, learningObject: learningObject, allowRetry: false });
	                            }, Math.round((Math.random() + 0.5) * 500));
	                            return [2 /*return*/, false];
	                        }
	                        // Alert the user
	                        alert("Der opstod en fejl, da vi fors\u00F8gte at fjerne \"" + learningObject.title + "\" fra dine favoritter.");
	                        // Hide the throbber
	                        btn.classList.remove('gLightbox-header-btn-throbber');
	                        setTimeout(function () {
	                            btn.classList.remove('gLightbox-header-btn-spin');
	                        }, 125);
	                        return [2 /*return*/, false];
	                    case 8:
	                        // Toggle favorite on/off
	                        this.favorites[learningObject.id] = !this.favorites[learningObject.id];
	                        // Wait the minimum duration before updating the UI
	                        return [4 /*yield*/, new Promise(function (resolve) {
	                                setTimeout(resolve, Math.max(0, minDuration - (Date.now() - startedAt)));
	                            })];
	                    case 9:
	                        // Wait the minimum duration before updating the UI
	                        _c.sent();
	                        // Update class
	                        if (this.favorites[learningObject.id]) {
	                            btn.classList.add('gLightbox-icon-favorite-on');
	                        }
	                        else {
	                            btn.classList.remove('gLightbox-icon-favorite-on');
	                        }
	                        // Hide throbber again
	                        btn.classList.remove('gLightbox-header-btn-throbber');
	                        setTimeout(function () {
	                            btn.classList.remove('gLightbox-header-btn-spin');
	                        }, 125);
	                        // Show a checkmark for the next two seconds
	                        btn.classList.add('gLightbox-header-btn-favorite-updated');
	                        btn.classList.add('gLightbox-header-btn-checkmark');
	                        setTimeout(function () {
	                            btn.classList.remove('gLightbox-header-btn-favorite-updated');
	                            btn.classList.remove('gLightbox-header-btn-checkmark');
	                        }, 1500);
	                        // Assume that the favorite-status was toggled correctly
	                        return [2 /*return*/, true];
	                }
	            });
	        });
	    };
	    /**
	     * Helper-method that opens the notebook associated with the currently
	     * embedded contents in a new window.
	     */
	    gLightbox.prototype.openNotebook = function () {
	        var options = this.options[this.index];
	        // Generate base URL
	        var url = config_1.default.API.notebook.replace('%id%', encodeURIComponent(options.productId));
	        // Append context to URL
	        if (options.learningObject) {
	            url += '&context-learningObjectId=' + encodeURIComponent(options.learningObject.id);
	            url += '&context-learningObjectTitle=' + encodeURIComponent(options.learningObject.title);
	            url += '&context-learningObjectType=' + encodeURIComponent(options.learningObject.type);
	        }
	        // Forward through the node.js proxy to ensure authentication
	        url = window.gProxy.forwardTo(url, 'notebook-3.0');
	        // // Open in a new window that's centered around the current window
	        window.open(url, 'notebook', 'left=' + (window.screenLeft + 50) + ',top=' + (window.screenTop + 50) + ',width=' + (window.innerWidth - 100) + ',height=' + (window.innerHeight - 100));
	    };
	    /** Internal helper that converts nanoajax-requests into a promise */
	    gLightbox.ajax = function (params) {
	        return $.ajax(params);
	    };
	    __decorate([
	        core_decorators_1.autobind
	    ], gLightbox.prototype, "onKeyPress", null);
	    return gLightbox;
	}());
	;
	// Expose class publicly
	window.gLightbox = gLightbox;


/***/ }),
/* 2 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(3);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(10)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../node_modules/css-loader/index.js?minimize!../../node_modules/postcss-loader/index.js!../../node_modules/sass-loader/index.js!./gLightbox.scss", function() {
				var newContent = require("!!../../node_modules/css-loader/index.js?minimize!../../node_modules/postcss-loader/index.js!../../node_modules/sass-loader/index.js!./gLightbox.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 3 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(4)();
	// imports
	exports.i(__webpack_require__(5), "");
	
	// module
	exports.push([module.id, ".gLightbox{position:fixed;top:0;left:0;bottom:0;right:0;z-index:1999999;background:#fff;animation:gLightbox-open cubic-bezier(.86,0,.07,1) 625ms}.gLightbox.gLightbox-closing{animation:gLightbox-close cubic-bezier(.86,0,.07,1) 625ms;animation-fill-mode:forwards}.gLightbox-wrapper{position:absolute;top:0;left:0;bottom:0;right:0;-webkit-backface-visibility:hidden;backface-visibility:hidden}.gLightbox-wrapper.gLightbox-wrapper-transition-in-left{animation:gLightbox-wrapper-transition-in-left cubic-bezier(.77,0,.175,1) 625ms}.gLightbox-wrapper.gLightbox-wrapper-transition-in-right{animation:gLightbox-wrapper-transition-in-right cubic-bezier(.77,0,.175,1) 625ms}.gLightbox-wrapper.gLightbox-wrapper-transition-out-left{animation:gLightbox-wrapper-transition-out-left cubic-bezier(.77,0,.175,1) 625ms;animation-fill-mode:forwards}.gLightbox-wrapper.gLightbox-wrapper-transition-out-right{animation:gLightbox-wrapper-transition-out-right cubic-bezier(.77,0,.175,1) 625ms;animation-fill-mode:forwards}.gLightbox-header{position:absolute;top:0;left:0;right:0;z-index:2;height:45px;text-align:right;font:0/0 serif;background:#fff;box-shadow:0 0 20px rgba(0,0,0,.15);-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none}.gLightbox-header-title{float:left;margin:0 0 0 14px;padding:0;font:500 17px/45px franklin-gothic-urw,droid-sans,helvetica,arial,sans-serif;overflow:hidden;text-overflow:ellipsis;white-space:nowrap;max-width:calc(100vw - 200px)}.gLightbox-header-hasNav .gLightbox-header-title{max-width:calc(50vw - 125px)}@media (max-width:767px){.gLightbox-header-title{display:none}}.gLightbox-header-due{position:relative;padding-left:35px;float:left;margin-left:14px;font:500 15px/43px franklin-gothic-urw,droid-sans,helvetica,arial,sans-serif;color:#dc4320;transition:color 125ms linear,opacity 225ms linear,transform 225ms cubic-bezier(.645,.045,.355,1);opacity:0;transform:translateX(-5px)}.gLightbox-header-due .gLightbox-icon-calendar{position:absolute;top:-2px;left:0;font-size:27px}.gLightbox-header-due .gLightbox-icon-calendar:before{content:\"\\E903\"}.gLightbox-header-due.gLightbox-header-due-ok{color:#46ca11}.gLightbox-header-due.gLightbox-header-due-overdue{color:#f2392f}.gLightbox-header-due.gLightbox-header-due-overdue .gLightbox-icon-calendar:before{content:\"\\E904\"}.gLightbox-header-due.gLightbox-header-due-visible{opacity:1;transform:translateX(0)}.gLightbox-header-nav{position:absolute;top:0;left:0;right:0;text-align:center;font:500 17px/43px franklin-gothic-urw,droid-sans,helvetica,arial,sans-serif}@media (max-width:767px){.gLightbox-header-nav{display:none}}.gLightbox-header-nav-next,.gLightbox-header-nav-prev{vertical-align:top;position:relative;top:-5px;display:inline-block;padding:5px;margin:0 25px;font-size:19px;transition:color 125ms linear;color:#383838;cursor:pointer}.gLightbox-interface-mouse .gLightbox-header-nav-next:hover,.gLightbox-interface-mouse .gLightbox-header-nav-prev:hover,.gLightbox-interface-touch .gLightbox-header-nav-next:active,.gLightbox-interface-touch .gLightbox-header-nav-prev:active{color:#dc4320}.gLightbox-header-nav-next.gLightbox-header-nav-disabled,.gLightbox-header-nav-prev.gLightbox-header-nav-disabled{opacity:.4;cursor:default}.gLightbox-interface-mouse .gLightbox-header-nav-next.gLightbox-header-nav-disabled:hover,.gLightbox-interface-mouse .gLightbox-header-nav-prev.gLightbox-header-nav-disabled:hover,.gLightbox-interface-touch .gLightbox-header-nav-next.gLightbox-header-nav-disabled:active,.gLightbox-interface-touch .gLightbox-header-nav-prev.gLightbox-header-nav-disabled:active{color:#383838}.gLightbox-header-nav-prev:before{display:inline-block;transform:rotate(180deg)}.gLightbox-header-btn{position:relative;display:inline-block;width:31px;height:31px;margin-top:7px;margin-right:10px;font-size:13px;line-height:31px;text-align:center;color:#383838;transition:color 125ms linear;cursor:pointer}.gLightbox-header-btn:after{position:absolute;top:0;left:0;bottom:0;right:0;transform-origin:15.5px 15.5px;border:2px solid #383838;border-radius:50%;transition:border-color 125ms linear;content:\"\"}.gLightbox-header-btn.gLightbox-header-btn-spin:after{animation:gLightbox-spin linear .9s infinite}.gLightbox-header-btn:before{transition:transform 275ms cubic-bezier(.645,.045,.355,1),opacity 275ms cubic-bezier(.645,.045,.355,1)}.gLightbox-header-btn.gLightbox-icon-checkmark:before{font-size:11px;transform:translateY(-2px)}.gLightbox-interface-mouse .gLightbox-header-btn:hover,.gLightbox-interface-touch .gLightbox-header-btn:active{color:#dc4320}.gLightbox-interface-mouse .gLightbox-header-btn:hover:after,.gLightbox-interface-touch .gLightbox-header-btn:active:after{border-color:#dc4320}.gLightbox-header-btn.gLightbox-header-btn-throbber:after{border-top-color:rgba(56,56,56,.25)}.gLightbox-interface-mouse .gLightbox-header-btn.gLightbox-header-btn-throbber:hover:after,.gLightbox-interface-touch .gLightbox-header-btn.gLightbox-header-btn-throbber:active:after{border-top-color:rgba(220,67,32,.25)}.gLightbox-header-btn .gLightbox-header-btn-checkmarkContainer{position:absolute;top:0;left:0;bottom:0;right:0;transition:transform 275ms cubic-bezier(.645,.045,.355,1),opacity 275ms cubic-bezier(.645,.045,.355,1);opacity:0;transform:scale(0)}.gLightbox-header-btn .gLightbox-header-btn-checkmarkContainer:before{font-size:11px;transform:translateY(-2px)}.gLightbox-header-btn.gLightbox-header-btn-checkmark .gLightbox-header-btn-checkmarkContainer{opacity:1;transform:scale(1)}.gLightbox-header-btn.gLightbox-header-btn-checkmark:before{opacity:0;transform:scale(0)}.gLightbox-header-btn.gLightbox-header-btn-favorite-updated{color:#383838!important}.gLightbox-header-btn.gLightbox-header-btn-favorite-updated:after{border-color:#383838!important}.gLightbox-header-btn.gLightbox-header-btn-favorite-updated.gLightbox-icon-favorite-on{color:#ffb235!important}.gLightbox-header-btn.gLightbox-header-btn-favorite-updated.gLightbox-icon-favorite-on:after{border-color:#ffb235!important}.gLightbox-header-btn.gLightbox-icon-checkmark-ok{color:#46ca11!important;cursor:default}.gLightbox-header-btn.gLightbox-icon-checkmark-ok:after{border-color:#46ca11!important}.gLightbox-header-btn.gLightbox-icon-favorite-on{color:#ffb235}.gLightbox-header-btn.gLightbox-icon-favorite-on:after{border-color:#ffb235}.gLightbox-header-btn.gLightbox-icon-favorite-on.gLightbox-header-btn-throbber:after{border-top-color:rgba(255,178,53,.25)}.gLightbox-contents{position:absolute;top:45px;left:0;right:0;bottom:0;z-index:1}.gLightbox-contents:before{position:absolute;top:50%;left:50%;margin-left:-32px;margin-top:-32px;display:block;box-sizing:border-box;width:64px;height:64px;border:2px solid #ddd;border-top-color:#666;border-radius:50%;animation:gLightbox-spin linear .9s infinite;content:\"\";transition:opacity 275ms linear,visibility 0ms linear 275ms}.gLightbox-contents.gLightbox-contents-loaded:before{visibility:hidden;opacity:0}.gLightbox-contents-iframe,.gLightbox-contents-image,.gLightbox-contents-message{width:100%;height:100%;background:#fff;opacity:0;transition:opacity 275ms linear}.gLightbox-contents-loaded .gLightbox-contents-iframe,.gLightbox-contents-loaded .gLightbox-contents-image,.gLightbox-contents-loaded .gLightbox-contents-message{opacity:1}.gLightbox-contents-image{background:#000}.gLightbox-contents-message{background:#f5f5f5}.gLightbox-contents-message-label{font:500 17px/25px franklin-gothic-urw,droid-sans,helvetica,arial,sans-serif;color:#666;text-shadow:#fff 1px 1px 0;text-align:center}.gLightbox-contents-image-img,.gLightbox-contents-message-label{position:absolute;top:50%;left:50%;transform:translate(-50%,-50%)}.gLightbox-contents-image-img{max-width:100%;max-height:100%}@keyframes gLightbox-open{0%{transform:scale3d(1.1,1.1,1.1);opacity:0}to{transform:scaleX(1);opacity:1}}@keyframes gLightbox-close{0%{opacity:1}to{opacity:0}}@keyframes gLightbox-spin{0%{transform:rotate(0deg)}to{transform:rotate(1turn)}}@keyframes gLightbox-wrapper-transition-in-left{0%{opacity:0;transform:translateX(100%)}to{opacity:1;transform:translateX(0)}}@keyframes gLightbox-wrapper-transition-out-left{0%{opacity:1;transform:translateX(0)}to{opacity:0;transform:translateX(-100%)}}@keyframes gLightbox-wrapper-transition-in-right{0%{opacity:0;transform:translateX(-100%)}to{opacity:1;transform:translateX(0)}}@keyframes gLightbox-wrapper-transition-out-right{0%{opacity:1;transform:translateX(0)}to{opacity:0;transform:translateX(100%)}}", ""]);
	
	// exports


/***/ }),
/* 4 */
/***/ (function(module, exports) {

	/*
		MIT License http://www.opensource.org/licenses/mit-license.php
		Author Tobias Koppers @sokra
	*/
	// css base code, injected by the css-loader
	module.exports = function() {
		var list = [];
	
		// return the list of modules as css string
		list.toString = function toString() {
			var result = [];
			for(var i = 0; i < this.length; i++) {
				var item = this[i];
				if(item[2]) {
					result.push("@media " + item[2] + "{" + item[1] + "}");
				} else {
					result.push(item[1]);
				}
			}
			return result.join("");
		};
	
		// import a list of modules into the list
		list.i = function(modules, mediaQuery) {
			if(typeof modules === "string")
				modules = [[null, modules, ""]];
			var alreadyImportedModules = {};
			for(var i = 0; i < this.length; i++) {
				var id = this[i][0];
				if(typeof id === "number")
					alreadyImportedModules[id] = true;
			}
			for(i = 0; i < modules.length; i++) {
				var item = modules[i];
				// skip already imported module
				// this implementation is not 100% perfect for weird media query combinations
				//  when a module is imported multiple times with different media queries.
				//  I hope this will never occur (Hey this way we have smaller bundles)
				if(typeof item[0] !== "number" || !alreadyImportedModules[item[0]]) {
					if(mediaQuery && !item[2]) {
						item[2] = mediaQuery;
					} else if(mediaQuery) {
						item[2] = "(" + item[2] + ") and (" + mediaQuery + ")";
					}
					list.push(item);
				}
			}
		};
		return list;
	};


/***/ }),
/* 5 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(4)();
	// imports
	
	
	// module
	exports.push([module.id, "@font-face{font-family:gLightbox-icomoon;src:url(" + __webpack_require__(6) + ");src:url(" + __webpack_require__(6) + ") format(\"embedded-opentype\"),url(" + __webpack_require__(7) + ") format(\"truetype\"),url(" + __webpack_require__(8) + ") format(\"woff\"),url(" + __webpack_require__(9) + ") format(\"svg\");font-weight:400;font-style:normal}.gLightbox-icon{font-family:gLightbox-icomoon!important;speak:none;font-style:normal;font-weight:400;font-variant:normal;text-transform:none;-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale}.gLightbox-icon-calender2:before{content:\"\\E903\"}.gLightbox-icon-close:before{content:\"\\E900\"}.gLightbox-icon-star:before{content:\"\\E901\"}.gLightbox-icon-checkmark:before{content:\"\\E902\"}.gLightbox-icon-notebook:before{content:\"\\E932\"}.gLightbox-icon-nav:before{content:\"\\E933\"}.gLightbox-icon-calendar:before{content:\"\\E904\"}", ""]);
	
	// exports


/***/ }),
/* 6 */
/***/ (function(module, exports) {

	module.exports = "data:application/vnd.ms-fontobject;base64,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"

/***/ }),
/* 7 */
/***/ (function(module, exports) {

	module.exports = "data:application/x-font-ttf;base64,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"

/***/ }),
/* 8 */
/***/ (function(module, exports) {

	module.exports = "data:application/font-woff;base64,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"

/***/ }),
/* 9 */
/***/ (function(module, exports) {

	module.exports = "data:image/svg+xml;base64,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"

/***/ }),
/* 10 */
/***/ (function(module, exports, __webpack_require__) {

	/*
		MIT License http://www.opensource.org/licenses/mit-license.php
		Author Tobias Koppers @sokra
	*/
	var stylesInDom = {},
		memoize = function(fn) {
			var memo;
			return function () {
				if (typeof memo === "undefined") memo = fn.apply(this, arguments);
				return memo;
			};
		},
		isOldIE = memoize(function() {
			return /msie [6-9]\b/.test(self.navigator.userAgent.toLowerCase());
		}),
		getHeadElement = memoize(function () {
			return document.head || document.getElementsByTagName("head")[0];
		}),
		singletonElement = null,
		singletonCounter = 0,
		styleElementsInsertedAtTop = [];
	
	module.exports = function(list, options) {
		if(false) {
			if(typeof document !== "object") throw new Error("The style-loader cannot be used in a non-browser environment");
		}
	
		options = options || {};
		// Force single-tag solution on IE6-9, which has a hard limit on the # of <style>
		// tags it will allow on a page
		if (typeof options.singleton === "undefined") options.singleton = isOldIE();
	
		// By default, add <style> tags to the bottom of <head>.
		if (typeof options.insertAt === "undefined") options.insertAt = "bottom";
	
		var styles = listToStyles(list);
		addStylesToDom(styles, options);
	
		return function update(newList) {
			var mayRemove = [];
			for(var i = 0; i < styles.length; i++) {
				var item = styles[i];
				var domStyle = stylesInDom[item.id];
				domStyle.refs--;
				mayRemove.push(domStyle);
			}
			if(newList) {
				var newStyles = listToStyles(newList);
				addStylesToDom(newStyles, options);
			}
			for(var i = 0; i < mayRemove.length; i++) {
				var domStyle = mayRemove[i];
				if(domStyle.refs === 0) {
					for(var j = 0; j < domStyle.parts.length; j++)
						domStyle.parts[j]();
					delete stylesInDom[domStyle.id];
				}
			}
		};
	}
	
	function addStylesToDom(styles, options) {
		for(var i = 0; i < styles.length; i++) {
			var item = styles[i];
			var domStyle = stylesInDom[item.id];
			if(domStyle) {
				domStyle.refs++;
				for(var j = 0; j < domStyle.parts.length; j++) {
					domStyle.parts[j](item.parts[j]);
				}
				for(; j < item.parts.length; j++) {
					domStyle.parts.push(addStyle(item.parts[j], options));
				}
			} else {
				var parts = [];
				for(var j = 0; j < item.parts.length; j++) {
					parts.push(addStyle(item.parts[j], options));
				}
				stylesInDom[item.id] = {id: item.id, refs: 1, parts: parts};
			}
		}
	}
	
	function listToStyles(list) {
		var styles = [];
		var newStyles = {};
		for(var i = 0; i < list.length; i++) {
			var item = list[i];
			var id = item[0];
			var css = item[1];
			var media = item[2];
			var sourceMap = item[3];
			var part = {css: css, media: media, sourceMap: sourceMap};
			if(!newStyles[id])
				styles.push(newStyles[id] = {id: id, parts: [part]});
			else
				newStyles[id].parts.push(part);
		}
		return styles;
	}
	
	function insertStyleElement(options, styleElement) {
		var head = getHeadElement();
		var lastStyleElementInsertedAtTop = styleElementsInsertedAtTop[styleElementsInsertedAtTop.length - 1];
		if (options.insertAt === "top") {
			if(!lastStyleElementInsertedAtTop) {
				head.insertBefore(styleElement, head.firstChild);
			} else if(lastStyleElementInsertedAtTop.nextSibling) {
				head.insertBefore(styleElement, lastStyleElementInsertedAtTop.nextSibling);
			} else {
				head.appendChild(styleElement);
			}
			styleElementsInsertedAtTop.push(styleElement);
		} else if (options.insertAt === "bottom") {
			head.appendChild(styleElement);
		} else {
			throw new Error("Invalid value for parameter 'insertAt'. Must be 'top' or 'bottom'.");
		}
	}
	
	function removeStyleElement(styleElement) {
		styleElement.parentNode.removeChild(styleElement);
		var idx = styleElementsInsertedAtTop.indexOf(styleElement);
		if(idx >= 0) {
			styleElementsInsertedAtTop.splice(idx, 1);
		}
	}
	
	function createStyleElement(options) {
		var styleElement = document.createElement("style");
		styleElement.type = "text/css";
		insertStyleElement(options, styleElement);
		return styleElement;
	}
	
	function createLinkElement(options) {
		var linkElement = document.createElement("link");
		linkElement.rel = "stylesheet";
		insertStyleElement(options, linkElement);
		return linkElement;
	}
	
	function addStyle(obj, options) {
		var styleElement, update, remove;
	
		if (options.singleton) {
			var styleIndex = singletonCounter++;
			styleElement = singletonElement || (singletonElement = createStyleElement(options));
			update = applyToSingletonTag.bind(null, styleElement, styleIndex, false);
			remove = applyToSingletonTag.bind(null, styleElement, styleIndex, true);
		} else if(obj.sourceMap &&
			typeof URL === "function" &&
			typeof URL.createObjectURL === "function" &&
			typeof URL.revokeObjectURL === "function" &&
			typeof Blob === "function" &&
			typeof btoa === "function") {
			styleElement = createLinkElement(options);
			update = updateLink.bind(null, styleElement);
			remove = function() {
				removeStyleElement(styleElement);
				if(styleElement.href)
					URL.revokeObjectURL(styleElement.href);
			};
		} else {
			styleElement = createStyleElement(options);
			update = applyToTag.bind(null, styleElement);
			remove = function() {
				removeStyleElement(styleElement);
			};
		}
	
		update(obj);
	
		return function updateStyle(newObj) {
			if(newObj) {
				if(newObj.css === obj.css && newObj.media === obj.media && newObj.sourceMap === obj.sourceMap)
					return;
				update(obj = newObj);
			} else {
				remove();
			}
		};
	}
	
	var replaceText = (function () {
		var textStore = [];
	
		return function (index, replacement) {
			textStore[index] = replacement;
			return textStore.filter(Boolean).join('\n');
		};
	})();
	
	function applyToSingletonTag(styleElement, index, remove, obj) {
		var css = remove ? "" : obj.css;
	
		if (styleElement.styleSheet) {
			styleElement.styleSheet.cssText = replaceText(index, css);
		} else {
			var cssNode = document.createTextNode(css);
			var childNodes = styleElement.childNodes;
			if (childNodes[index]) styleElement.removeChild(childNodes[index]);
			if (childNodes.length) {
				styleElement.insertBefore(cssNode, childNodes[index]);
			} else {
				styleElement.appendChild(cssNode);
			}
		}
	}
	
	function applyToTag(styleElement, obj) {
		var css = obj.css;
		var media = obj.media;
	
		if(media) {
			styleElement.setAttribute("media", media)
		}
	
		if(styleElement.styleSheet) {
			styleElement.styleSheet.cssText = css;
		} else {
			while(styleElement.firstChild) {
				styleElement.removeChild(styleElement.firstChild);
			}
			styleElement.appendChild(document.createTextNode(css));
		}
	}
	
	function updateLink(linkElement, obj) {
		var css = obj.css;
		var sourceMap = obj.sourceMap;
	
		if(sourceMap) {
			// http://stackoverflow.com/a/26603875
			css += "\n/*# sourceMappingURL=data:application/json;base64," + btoa(unescape(encodeURIComponent(JSON.stringify(sourceMap)))) + " */";
		}
	
		var blob = new Blob([css], { type: "text/css" });
	
		var oldSrc = linkElement.href;
	
		linkElement.href = URL.createObjectURL(blob);
	
		if(oldSrc)
			URL.revokeObjectURL(oldSrc);
	}


/***/ }),
/* 11 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * core-decorators.js
	 * (c) 2016 Jay Phelps and contributors
	 * MIT Licensed
	 * https://github.com/jayphelps/core-decorators.js
	 * @license
	 */
	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequire(obj) { return obj && obj.__esModule ? obj['default'] : obj; }
	
	var _override = __webpack_require__(12);
	
	exports.override = _interopRequire(_override);
	
	var _deprecate = __webpack_require__(15);
	
	exports.deprecate = _interopRequire(_deprecate);
	exports.deprecated = _interopRequire(_deprecate);
	
	var _suppressWarnings = __webpack_require__(16);
	
	exports.suppressWarnings = _interopRequire(_suppressWarnings);
	
	var _memoize = __webpack_require__(17);
	
	exports.memoize = _interopRequire(_memoize);
	
	var _autobind = __webpack_require__(18);
	
	exports.autobind = _interopRequire(_autobind);
	
	var _readonly = __webpack_require__(19);
	
	exports.readonly = _interopRequire(_readonly);
	
	var _enumerable = __webpack_require__(20);
	
	exports.enumerable = _interopRequire(_enumerable);
	
	var _nonenumerable = __webpack_require__(21);
	
	exports.nonenumerable = _interopRequire(_nonenumerable);
	
	var _nonconfigurable = __webpack_require__(22);
	
	exports.nonconfigurable = _interopRequire(_nonconfigurable);
	
	var _debounce = __webpack_require__(23);
	
	exports.debounce = _interopRequire(_debounce);
	
	var _throttle = __webpack_require__(24);
	
	exports.throttle = _interopRequire(_throttle);
	
	var _decorate = __webpack_require__(25);
	
	exports.decorate = _interopRequire(_decorate);
	
	var _mixin = __webpack_require__(26);
	
	exports.mixin = _interopRequire(_mixin);
	exports.mixins = _interopRequire(_mixin);
	
	var _lazyInitialize = __webpack_require__(14);
	
	exports.lazyInitialize = _interopRequire(_lazyInitialize);
	
	var _time = __webpack_require__(27);
	
	exports.time = _interopRequire(_time);
	
	var _extendDescriptor = __webpack_require__(28);
	
	exports.extendDescriptor = _interopRequire(_extendDescriptor);
	
	// Helper to apply decorators to a class without transpiler support
	
	var _applyDecorators = __webpack_require__(29);
	
	exports.applyDecorators = _interopRequire(_applyDecorators);

/***/ }),
/* 12 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	exports['default'] = override;
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	var _privateUtils = __webpack_require__(13);
	
	var GENERIC_FUNCTION_ERROR = '{child} does not properly override {parent}';
	var FUNCTION_REGEXP = /^function ([_$a-zA-Z\xA0-\uFFFF][_$a-zA-Z0-9\xA0-\uFFFF]*)?(\([^\)]*\))[\s\S]+$/;
	
	var SyntaxErrorReporter = (function () {
	  _createClass(SyntaxErrorReporter, [{
	    key: '_getTopic',
	    value: function _getTopic(descriptor) {
	      if (descriptor === undefined) {
	        return null;
	      }
	
	      if ('value' in descriptor) {
	        return descriptor.value;
	      }
	
	      if ('get' in descriptor) {
	        return descriptor.get;
	      }
	
	      if ('set' in descriptor) {
	        return descriptor.set;
	      }
	    }
	  }, {
	    key: '_extractTopicSignature',
	    value: function _extractTopicSignature(topic) {
	      switch (typeof topic) {
	        case 'function':
	          return this._extractFunctionSignature(topic);
	        default:
	          return this.key;
	      }
	    }
	  }, {
	    key: '_extractFunctionSignature',
	    value: function _extractFunctionSignature(fn) {
	      var _this = this;
	
	      return fn.toString().replace(FUNCTION_REGEXP, function (match, name, params) {
	        if (name === undefined) name = _this.key;
	        return name + params;
	      });
	    }
	  }, {
	    key: 'key',
	    get: function get() {
	      return this.childDescriptor.key;
	    }
	  }, {
	    key: 'parentNotation',
	    get: function get() {
	      return this.parentKlass.constructor.name + '#' + this.parentPropertySignature;
	    }
	  }, {
	    key: 'childNotation',
	    get: function get() {
	      return this.childKlass.constructor.name + '#' + this.childPropertySignature;
	    }
	  }, {
	    key: 'parentTopic',
	    get: function get() {
	      return this._getTopic(this.parentDescriptor);
	    }
	  }, {
	    key: 'childTopic',
	    get: function get() {
	      return this._getTopic(this.childDescriptor);
	    }
	  }, {
	    key: 'parentPropertySignature',
	    get: function get() {
	      return this._extractTopicSignature(this.parentTopic);
	    }
	  }, {
	    key: 'childPropertySignature',
	    get: function get() {
	      return this._extractTopicSignature(this.childTopic);
	    }
	  }]);
	
	  function SyntaxErrorReporter(parentKlass, childKlass, parentDescriptor, childDescriptor) {
	    _classCallCheck(this, SyntaxErrorReporter);
	
	    this.parentKlass = parentKlass;
	    this.childKlass = childKlass;
	    this.parentDescriptor = parentDescriptor;
	    this.childDescriptor = childDescriptor;
	  }
	
	  _createClass(SyntaxErrorReporter, [{
	    key: 'assert',
	    value: function assert(condition) {
	      var msg = arguments.length <= 1 || arguments[1] === undefined ? '' : arguments[1];
	
	      if (condition !== true) {
	        this.error(GENERIC_FUNCTION_ERROR + msg);
	      }
	    }
	  }, {
	    key: 'error',
	    value: function error(msg) {
	      var _this2 = this;
	
	      msg = msg
	      // Replace lazily, because they actually might not
	      // be available in all cases
	      .replace('{parent}', function (m) {
	        return _this2.parentNotation;
	      }).replace('{child}', function (m) {
	        return _this2.childNotation;
	      });
	      throw new SyntaxError(msg);
	    }
	  }]);
	
	  return SyntaxErrorReporter;
	})();
	
	function getDescriptorType(descriptor) {
	  if (descriptor.hasOwnProperty('value')) {
	    return 'data';
	  }
	
	  if (descriptor.hasOwnProperty('get') || descriptor.hasOwnProperty('set')) {
	    return 'accessor';
	  }
	
	  // If none of them exist, browsers treat it as
	  // a data descriptor with a value of `undefined`
	  return 'data';
	}
	
	function checkFunctionSignatures(parent, child, reporter) {
	  reporter.assert(parent.length === child.length);
	}
	
	function checkDataDescriptors(parent, child, reporter) {
	  var parentValueType = typeof parent.value;
	  var childValueType = typeof child.value;
	
	  if (parentValueType === 'undefined' && childValueType === 'undefined') {
	    // class properties can be any expression, which isn't ran until the
	    // the instance is created, so we can't reliably get type information
	    // for them yet (per spec). Perhaps when Babel includes flow-type info
	    // in runtime? Tried regex solutions, but super hacky and only feasible
	    // on primitives, which is confusing for usage...
	    reporter.error('descriptor values are both undefined. (class properties are are not currently supported)\'');
	  }
	
	  if (parentValueType !== childValueType) {
	    var isFunctionOverUndefined = childValueType === 'function' && parentValueType === undefined;
	    // Even though we don't support class properties, this
	    // will still handle more than just functions, just in case.
	    // Shadowing an undefined value is an error if the inherited
	    // value was undefined (usually a class property, not a method)
	    if (isFunctionOverUndefined || parentValueType !== undefined) {
	      reporter.error('value types do not match. {parent} is "' + parentValueType + '", {child} is "' + childValueType + '"');
	    }
	  }
	
	  // Switch, in preparation for supporting more types
	  switch (childValueType) {
	    case 'function':
	      checkFunctionSignatures(parent.value, child.value, reporter);
	      break;
	
	    default:
	      reporter.error('Unexpected error. Please file a bug with: {parent} is "' + parentValueType + '", {child} is "' + childValueType + '"');
	      break;
	  }
	}
	
	function checkAccessorDescriptors(parent, child, reporter) {
	  var parentHasGetter = typeof parent.get === 'function';
	  var childHasGetter = typeof child.get === 'function';
	  var parentHasSetter = typeof parent.set === 'function';
	  var childHasSetter = typeof child.set === 'function';
	
	  if (parentHasGetter || childHasGetter) {
	    if (!parentHasGetter && parentHasSetter) {
	      reporter.error('{parent} is setter but {child} is getter');
	    }
	
	    if (!childHasGetter && childHasSetter) {
	      reporter.error('{parent} is getter but {child} is setter');
	    }
	
	    checkFunctionSignatures(parent.get, child.get, reporter);
	  }
	
	  if (parentHasSetter || childHasSetter) {
	    if (!parentHasSetter && parentHasGetter) {
	      reporter.error('{parent} is getter but {child} is setter');
	    }
	
	    if (!childHasSetter && childHasGetter) {
	      reporter.error('{parent} is setter but {child} is getter');
	    }
	
	    checkFunctionSignatures(parent.set, child.set, reporter);
	  }
	}
	
	function checkDescriptors(parent, child, reporter) {
	  var parentType = getDescriptorType(parent);
	  var childType = getDescriptorType(child);
	
	  if (parentType !== childType) {
	    reporter.error('descriptor types do not match. {parent} is "' + parentType + '", {child} is "' + childType + '"');
	  }
	
	  switch (childType) {
	    case 'data':
	      checkDataDescriptors(parent, child, reporter);
	      break;
	
	    case 'accessor':
	      checkAccessorDescriptors(parent, child, reporter);
	      break;
	  }
	}
	
	var suggestionTransforms = [function (key) {
	  return key.toLowerCase();
	}, function (key) {
	  return key.toUpperCase();
	}, function (key) {
	  return key + 's';
	}, function (key) {
	  return key.slice(0, -1);
	}, function (key) {
	  return key.slice(1, key.length);
	}];
	
	function findPossibleAlternatives(superKlass, key) {
	  var _iteratorNormalCompletion = true;
	  var _didIteratorError = false;
	  var _iteratorError = undefined;
	
	  try {
	    for (var _iterator = suggestionTransforms[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
	      var fn = _step.value;
	
	      var suggestion = fn(key);
	      if (suggestion in superKlass) {
	        return suggestion;
	      }
	    }
	  } catch (err) {
	    _didIteratorError = true;
	    _iteratorError = err;
	  } finally {
	    try {
	      if (!_iteratorNormalCompletion && _iterator['return']) {
	        _iterator['return']();
	      }
	    } finally {
	      if (_didIteratorError) {
	        throw _iteratorError;
	      }
	    }
	  }
	
	  return null;
	}
	
	function handleDescriptor(target, key, descriptor) {
	  descriptor.key = key;
	  var superKlass = Object.getPrototypeOf(target);
	  var superDescriptor = Object.getOwnPropertyDescriptor(superKlass, key);
	  var reporter = new SyntaxErrorReporter(superKlass, target, superDescriptor, descriptor);
	
	  if (superDescriptor === undefined) {
	    var suggestedKey = findPossibleAlternatives(superKlass, key);
	    var suggestion = suggestedKey ? '\n\n  Did you mean "' + suggestedKey + '"?' : '';
	    reporter.error('No descriptor matching {child} was found on the prototype chain.' + suggestion);
	  }
	
	  checkDescriptors(superDescriptor, descriptor, reporter);
	
	  return descriptor;
	}
	
	function override() {
	  for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	    args[_key] = arguments[_key];
	  }
	
	  return (0, _privateUtils.decorate)(handleDescriptor, args);
	}
	
	module.exports = exports['default'];

/***/ }),
/* 13 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	var _slice = Array.prototype.slice;
	
	var _createDecoratedClass = (function () { function defineProperties(target, descriptors, initializers) { for (var i = 0; i < descriptors.length; i++) { var descriptor = descriptors[i]; var decorators = descriptor.decorators; var key = descriptor.key; delete descriptor.key; delete descriptor.decorators; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor || descriptor.initializer) descriptor.writable = true; if (decorators) { for (var f = 0; f < decorators.length; f++) { var decorator = decorators[f]; if (typeof decorator === 'function') { descriptor = decorator(target, key, descriptor) || descriptor; } else { throw new TypeError('The decorator for method ' + descriptor.key + ' is of the invalid type ' + typeof decorator); } } if (descriptor.initializer !== undefined) { initializers[key] = descriptor; continue; } } Object.defineProperty(target, key, descriptor); } } return function (Constructor, protoProps, staticProps, protoInitializers, staticInitializers) { if (protoProps) defineProperties(Constructor.prototype, protoProps, protoInitializers); if (staticProps) defineProperties(Constructor, staticProps, staticInitializers); return Constructor; }; })();
	
	exports.isDescriptor = isDescriptor;
	exports.decorate = decorate;
	exports.metaFor = metaFor;
	exports.getOwnPropertyDescriptors = getOwnPropertyDescriptors;
	exports.createDefaultSetter = createDefaultSetter;
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) arr2[i] = arr[i]; return arr2; } else { return Array.from(arr); } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	function _defineDecoratedPropertyDescriptor(target, key, descriptors) { var _descriptor = descriptors[key]; if (!_descriptor) return; var descriptor = {}; for (var _key in _descriptor) descriptor[_key] = _descriptor[_key]; descriptor.value = descriptor.initializer ? descriptor.initializer.call(target) : undefined; Object.defineProperty(target, key, descriptor); }
	
	var _lazyInitialize = __webpack_require__(14);
	
	var _lazyInitialize2 = _interopRequireDefault(_lazyInitialize);
	
	var defineProperty = Object.defineProperty;
	var getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
	var getOwnPropertyNames = Object.getOwnPropertyNames;
	var getOwnPropertySymbols = Object.getOwnPropertySymbols;
	
	function isDescriptor(desc) {
	  if (!desc || !desc.hasOwnProperty) {
	    return false;
	  }
	
	  var keys = ['value', 'initializer', 'get', 'set'];
	
	  for (var i = 0, l = keys.length; i < l; i++) {
	    if (desc.hasOwnProperty(keys[i])) {
	      return true;
	    }
	  }
	
	  return false;
	}
	
	function decorate(handleDescriptor, entryArgs) {
	  if (isDescriptor(entryArgs[entryArgs.length - 1])) {
	    return handleDescriptor.apply(undefined, _toConsumableArray(entryArgs).concat([[]]));
	  } else {
	    return function () {
	      return handleDescriptor.apply(undefined, _slice.call(arguments).concat([entryArgs]));
	    };
	  }
	}
	
	var Meta = (function () {
	  var _instanceInitializers = {};
	
	  function Meta() {
	    _classCallCheck(this, Meta);
	
	    _defineDecoratedPropertyDescriptor(this, 'debounceTimeoutIds', _instanceInitializers);
	
	    _defineDecoratedPropertyDescriptor(this, 'throttleTimeoutIds', _instanceInitializers);
	
	    _defineDecoratedPropertyDescriptor(this, 'throttlePreviousTimestamps', _instanceInitializers);
	  }
	
	  _createDecoratedClass(Meta, [{
	    key: 'debounceTimeoutIds',
	    decorators: [_lazyInitialize2['default']],
	    initializer: function initializer() {
	      return {};
	    },
	    enumerable: true
	  }, {
	    key: 'throttleTimeoutIds',
	    decorators: [_lazyInitialize2['default']],
	    initializer: function initializer() {
	      return {};
	    },
	    enumerable: true
	  }, {
	    key: 'throttlePreviousTimestamps',
	    decorators: [_lazyInitialize2['default']],
	    initializer: function initializer() {
	      return {};
	    },
	    enumerable: true
	  }], null, _instanceInitializers);
	
	  return Meta;
	})();
	
	var META_KEY = typeof Symbol === 'function' ? Symbol('__core_decorators__') : '__core_decorators__';
	
	function metaFor(obj) {
	  if (obj.hasOwnProperty(META_KEY) === false) {
	    defineProperty(obj, META_KEY, {
	      // Defaults: NOT enumerable, configurable, or writable
	      value: new Meta()
	    });
	  }
	
	  return obj[META_KEY];
	}
	
	var getOwnKeys = getOwnPropertySymbols ? function (object) {
	  return getOwnPropertyNames(object).concat(getOwnPropertySymbols(object));
	} : getOwnPropertyNames;
	
	exports.getOwnKeys = getOwnKeys;
	
	function getOwnPropertyDescriptors(obj) {
	  var descs = {};
	
	  getOwnKeys(obj).forEach(function (key) {
	    return descs[key] = getOwnPropertyDescriptor(obj, key);
	  });
	
	  return descs;
	}
	
	function createDefaultSetter(key) {
	  return function set(newValue) {
	    Object.defineProperty(this, key, {
	      configurable: true,
	      writable: true,
	      // IS enumerable when reassigned by the outside word
	      enumerable: true,
	      value: newValue
	    });
	
	    return newValue;
	  };
	}

/***/ }),
/* 14 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	exports['default'] = lazyInitialize;
	
	var _privateUtils = __webpack_require__(13);
	
	function handleDescriptor(target, key, descriptor) {
	  var configurable = descriptor.configurable;
	  var enumerable = descriptor.enumerable;
	  var initializer = descriptor.initializer;
	  var value = descriptor.value;
	
	  return {
	    configurable: configurable,
	    enumerable: enumerable,
	
	    get: function get() {
	      // This happens if someone accesses the
	      // property directly on the prototype
	      if (this === target) {
	        return;
	      }
	
	      var ret = initializer ? initializer.call(this) : value;
	
	      Object.defineProperty(this, key, {
	        configurable: configurable,
	        enumerable: enumerable,
	        writable: true,
	        value: ret
	      });
	
	      return ret;
	    },
	
	    set: (0, _privateUtils.createDefaultSetter)(key)
	  };
	}
	
	function lazyInitialize() {
	  for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	    args[_key] = arguments[_key];
	  }
	
	  return (0, _privateUtils.decorate)(handleDescriptor, args);
	}
	
	module.exports = exports['default'];

/***/ }),
/* 15 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	var _slicedToArray = (function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i['return']) _i['return'](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError('Invalid attempt to destructure non-iterable instance'); } }; })();
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports['default'] = deprecate;
	
	var _privateUtils = __webpack_require__(13);
	
	var DEFAULT_MSG = 'This function will be removed in future versions.';
	
	function handleDescriptor(target, key, descriptor, _ref) {
	  var _ref2 = _slicedToArray(_ref, 2);
	
	  var _ref2$0 = _ref2[0];
	  var msg = _ref2$0 === undefined ? DEFAULT_MSG : _ref2$0;
	  var _ref2$1 = _ref2[1];
	  var options = _ref2$1 === undefined ? {} : _ref2$1;
	
	  if (typeof descriptor.value !== 'function') {
	    throw new SyntaxError('Only functions can be marked as deprecated');
	  }
	
	  var methodSignature = target.constructor.name + '#' + key;
	
	  if (options.url) {
	    msg += '\n\n    See ' + options.url + ' for more details.\n\n';
	  }
	
	  return _extends({}, descriptor, {
	    value: function deprecationWrapper() {
	      console.warn('DEPRECATION ' + methodSignature + ': ' + msg);
	      return descriptor.value.apply(this, arguments);
	    }
	  });
	}
	
	function deprecate() {
	  for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	    args[_key] = arguments[_key];
	  }
	
	  return (0, _privateUtils.decorate)(handleDescriptor, args);
	}
	
	module.exports = exports['default'];

/***/ }),
/* 16 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports['default'] = suppressWarnings;
	
	var _privateUtils = __webpack_require__(13);
	
	function suppressedWarningNoop() {
	  // Warnings are currently suppressed via @suppressWarnings
	}
	
	function applyWithoutWarnings(context, fn, args) {
	  var nativeWarn = console.warn;
	  console.warn = suppressedWarningNoop;
	  var ret = fn.apply(context, args);
	  console.warn = nativeWarn;
	  return ret;
	}
	
	function handleDescriptor(target, key, descriptor) {
	  return _extends({}, descriptor, {
	    value: function suppressWarningsWrapper() {
	      return applyWithoutWarnings(this, descriptor.value, arguments);
	    }
	  });
	}
	
	function suppressWarnings() {
	  for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	    args[_key] = arguments[_key];
	  }
	
	  return (0, _privateUtils.decorate)(handleDescriptor, args);
	}
	
	module.exports = exports['default'];

/***/ }),
/* 17 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports['default'] = memoize;
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var _privateUtils = __webpack_require__(13);
	
	function toObject(cache, value) {
	  if (value === Object(value)) {
	    return value;
	  }
	  return cache[value] || (cache[value] = {});
	}
	
	function applyAndCache(context, fn, args, cache, signature) {
	  var ret = fn.apply(context, args);
	  cache[signature] = ret;
	  return ret;
	}
	
	function metaForDescriptor(descriptor) {
	  var fn = undefined,
	      wrapKey = undefined;
	
	  // This is ugly code, but way faster than other
	  // ways I tried that *looked* pretty
	
	  if (descriptor.value) {
	    fn = descriptor.value;
	    wrapKey = 'value';
	  } else if (descriptor.get) {
	    fn = descriptor.get;
	    wrapKey = 'get';
	  } else if (descriptor.set) {
	    fn = descriptor.set;
	    wrapKey = 'set';
	  }
	
	  return { fn: fn, wrapKey: wrapKey };
	}
	
	function handleDescriptor(target, key, descriptor) {
	  console.warn('DEPRECATION: @memoize is deprecated and will be removed shortly. Use @decorate with lodash\'s memoize helper.\n\n  https://github.com/jayphelps/core-decorators.js#decorate');
	
	  var _metaForDescriptor = metaForDescriptor(descriptor);
	
	  var fn = _metaForDescriptor.fn;
	  var wrapKey = _metaForDescriptor.wrapKey;
	
	  var argumentCache = new WeakMap();
	  var signatureCache = Object.create(null);
	  var primativeRefCache = Object.create(null);
	  var argumentIdCounter = 0;
	
	  return _extends({}, descriptor, _defineProperty({}, wrapKey, function memoizeWrapper() {
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    var signature = '0';
	
	    for (var i = 0, l = args.length; i < l; i++) {
	      var arg = args[i];
	      var argRef = toObject(primativeRefCache, arg);
	      var argKey = argumentCache.get(argRef);
	
	      if (argKey === undefined) {
	        argKey = ++argumentIdCounter;
	        argumentCache.set(argRef, argKey);
	      }
	
	      signature += argKey;
	    }
	
	    return signatureCache[signature] || applyAndCache(this, fn, arguments, signatureCache, signature);
	  }));
	}
	
	function memoize() {
	  for (var _len2 = arguments.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
	    args[_key2] = arguments[_key2];
	  }
	
	  return (0, _privateUtils.decorate)(handleDescriptor, args);
	}
	
	module.exports = exports['default'];

/***/ }),
/* 18 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	exports['default'] = autobind;
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) arr2[i] = arr[i]; return arr2; } else { return Array.from(arr); } }
	
	var _privateUtils = __webpack_require__(13);
	
	var defineProperty = Object.defineProperty;
	
	function bind(fn, context) {
	  if (fn.bind) {
	    return fn.bind(context);
	  } else {
	    return function __autobind__() {
	      return fn.apply(context, arguments);
	    };
	  }
	}
	
	var mapStore = undefined;
	
	function getBoundSuper(obj, fn) {
	  if (typeof WeakMap === 'undefined') {
	    throw new Error('Using @autobind on ' + fn.name + '() requires WeakMap support due to its use of super.' + fn.name + '()\n      See https://github.com/jayphelps/core-decorators.js/issues/20');
	  }
	
	  if (!mapStore) {
	    mapStore = new WeakMap();
	  }
	
	  if (mapStore.has(obj) === false) {
	    mapStore.set(obj, new WeakMap());
	  }
	
	  var superStore = mapStore.get(obj);
	
	  if (superStore.has(fn) === false) {
	    superStore.set(fn, bind(fn, obj));
	  }
	
	  return superStore.get(fn);
	}
	
	function autobindClass(klass) {
	  var descs = (0, _privateUtils.getOwnPropertyDescriptors)(klass.prototype);
	
	  var _iteratorNormalCompletion = true;
	  var _didIteratorError = false;
	  var _iteratorError = undefined;
	
	  try {
	    for (var _iterator = (0, _privateUtils.getOwnKeys)(descs)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
	      var key = _step.value;
	
	      var desc = descs[key];
	      if (typeof desc.value !== 'function' || key === 'constructor') {
	        continue;
	      }
	
	      defineProperty(klass.prototype, key, autobindMethod(klass.prototype, key, desc));
	    }
	  } catch (err) {
	    _didIteratorError = true;
	    _iteratorError = err;
	  } finally {
	    try {
	      if (!_iteratorNormalCompletion && _iterator['return']) {
	        _iterator['return']();
	      }
	    } finally {
	      if (_didIteratorError) {
	        throw _iteratorError;
	      }
	    }
	  }
	}
	
	function autobindMethod(target, key, _ref) {
	  var fn = _ref.value;
	  var configurable = _ref.configurable;
	  var enumerable = _ref.enumerable;
	
	  if (typeof fn !== 'function') {
	    throw new SyntaxError('@autobind can only be used on functions, not: ' + fn);
	  }
	
	  var constructor = target.constructor;
	
	  return {
	    configurable: configurable,
	    enumerable: enumerable,
	
	    get: function get() {
	      // Class.prototype.key lookup
	      // Someone accesses the property directly on the prototype on which it is
	      // actually defined on, i.e. Class.prototype.hasOwnProperty(key)
	      if (this === target) {
	        return fn;
	      }
	
	      // Class.prototype.key lookup
	      // Someone accesses the property directly on a prototype but it was found
	      // up the chain, not defined directly on it
	      // i.e. Class.prototype.hasOwnProperty(key) == false && key in Class.prototype
	      if (this.constructor !== constructor && Object.getPrototypeOf(this).constructor === constructor) {
	        return fn;
	      }
	
	      // Autobound method calling super.sameMethod() which is also autobound and so on.
	      if (this.constructor !== constructor && key in this.constructor.prototype) {
	        return getBoundSuper(this, fn);
	      }
	
	      var boundFn = bind(fn, this);
	
	      defineProperty(this, key, {
	        configurable: true,
	        writable: true,
	        // NOT enumerable when it's a bound method
	        enumerable: false,
	        value: boundFn
	      });
	
	      return boundFn;
	    },
	    set: (0, _privateUtils.createDefaultSetter)(key)
	  };
	}
	
	function handle(args) {
	  if (args.length === 1) {
	    return autobindClass.apply(undefined, _toConsumableArray(args));
	  } else {
	    return autobindMethod.apply(undefined, _toConsumableArray(args));
	  }
	}
	
	function autobind() {
	  for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	    args[_key] = arguments[_key];
	  }
	
	  if (args.length === 0) {
	    return function () {
	      return handle(arguments);
	    };
	  } else {
	    return handle(args);
	  }
	}
	
	module.exports = exports['default'];

/***/ }),
/* 19 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	exports['default'] = readonly;
	
	var _privateUtils = __webpack_require__(13);
	
	function handleDescriptor(target, key, descriptor) {
	  descriptor.writable = false;
	  return descriptor;
	}
	
	function readonly() {
	  for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	    args[_key] = arguments[_key];
	  }
	
	  return (0, _privateUtils.decorate)(handleDescriptor, args);
	}
	
	module.exports = exports['default'];

/***/ }),
/* 20 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	exports['default'] = enumerable;
	
	var _privateUtils = __webpack_require__(13);
	
	function handleDescriptor(target, key, descriptor) {
	  descriptor.enumerable = true;
	  return descriptor;
	}
	
	function enumerable() {
	  for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	    args[_key] = arguments[_key];
	  }
	
	  return (0, _privateUtils.decorate)(handleDescriptor, args);
	}
	
	module.exports = exports['default'];

/***/ }),
/* 21 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	exports['default'] = nonenumerable;
	
	var _privateUtils = __webpack_require__(13);
	
	function handleDescriptor(target, key, descriptor) {
	  descriptor.enumerable = false;
	  return descriptor;
	}
	
	function nonenumerable() {
	  for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	    args[_key] = arguments[_key];
	  }
	
	  return (0, _privateUtils.decorate)(handleDescriptor, args);
	}
	
	module.exports = exports['default'];

/***/ }),
/* 22 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	exports['default'] = nonconfigurable;
	
	var _privateUtils = __webpack_require__(13);
	
	function handleDescriptor(target, key, descriptor) {
	  descriptor.configurable = false;
	  return descriptor;
	}
	
	function nonconfigurable() {
	  for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	    args[_key] = arguments[_key];
	  }
	
	  return (0, _privateUtils.decorate)(handleDescriptor, args);
	}
	
	module.exports = exports['default'];

/***/ }),
/* 23 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	var _slicedToArray = (function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i['return']) _i['return'](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError('Invalid attempt to destructure non-iterable instance'); } }; })();
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports['default'] = debounce;
	
	var _privateUtils = __webpack_require__(13);
	
	var DEFAULT_TIMEOUT = 300;
	
	function handleDescriptor(target, key, descriptor, _ref) {
	  var _ref2 = _slicedToArray(_ref, 2);
	
	  var _ref2$0 = _ref2[0];
	  var wait = _ref2$0 === undefined ? DEFAULT_TIMEOUT : _ref2$0;
	  var _ref2$1 = _ref2[1];
	  var immediate = _ref2$1 === undefined ? false : _ref2$1;
	
	  var callback = descriptor.value;
	
	  if (typeof callback !== 'function') {
	    throw new SyntaxError('Only functions can be debounced');
	  }
	
	  return _extends({}, descriptor, {
	    value: function value() {
	      var _this = this;
	
	      var _metaFor = (0, _privateUtils.metaFor)(this);
	
	      var debounceTimeoutIds = _metaFor.debounceTimeoutIds;
	
	      var timeout = debounceTimeoutIds[key];
	      var callNow = immediate && !timeout;
	      var args = arguments;
	
	      clearTimeout(timeout);
	
	      debounceTimeoutIds[key] = setTimeout(function () {
	        delete debounceTimeoutIds[key];
	        if (!immediate) {
	          callback.apply(_this, args);
	        }
	      }, wait);
	
	      if (callNow) {
	        callback.apply(this, args);
	      }
	    }
	  });
	}
	
	function debounce() {
	  for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	    args[_key] = arguments[_key];
	  }
	
	  return (0, _privateUtils.decorate)(handleDescriptor, args);
	}
	
	module.exports = exports['default'];

/***/ }),
/* 24 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	var _slicedToArray = (function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i['return']) _i['return'](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError('Invalid attempt to destructure non-iterable instance'); } }; })();
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports['default'] = throttle;
	
	var _privateUtils = __webpack_require__(13);
	
	var DEFAULT_TIMEOUT = 300;
	
	function handleDescriptor(target, key, descriptor, _ref) {
	  var _ref2 = _slicedToArray(_ref, 2);
	
	  var _ref2$0 = _ref2[0];
	  var wait = _ref2$0 === undefined ? DEFAULT_TIMEOUT : _ref2$0;
	  var _ref2$1 = _ref2[1];
	  var options = _ref2$1 === undefined ? {} : _ref2$1;
	
	  var callback = descriptor.value;
	
	  if (typeof callback !== 'function') {
	    throw new SyntaxError('Only functions can be throttled');
	  }
	
	  if (options.leading !== false) {
	    options.leading = true;
	  }
	
	  if (options.trailing !== false) {
	    options.trailing = true;
	  }
	
	  return _extends({}, descriptor, {
	    value: function value() {
	      var _this = this;
	
	      var _metaFor = (0, _privateUtils.metaFor)(this);
	
	      var throttleTimeoutIds = _metaFor.throttleTimeoutIds;
	      var throttlePreviousTimestamps = _metaFor.throttlePreviousTimestamps;
	
	      var timeout = throttleTimeoutIds[key];
	      // last execute timestamp
	      var previous = throttlePreviousTimestamps[key] || 0;
	      var now = Date.now();
	      var args = arguments;
	
	      // if first be called and disable the execution on the leading edge
	      // set last execute timestamp to now
	      if (!previous && options.leading === false) {
	        previous = now;
	      }
	
	      var remaining = wait - (now - previous);
	
	      if (remaining <= 0) {
	        clearTimeout(timeout);
	        delete throttleTimeoutIds[key];
	        throttlePreviousTimestamps[key] = now;
	        callback.apply(this, args);
	      } else if (!timeout && options.trailing !== false) {
	        throttleTimeoutIds[key] = setTimeout(function () {
	          throttlePreviousTimestamps[key] = options.leading === false ? 0 : Date.now();
	          delete throttleTimeoutIds[key];
	          callback.apply(_this, args);
	        }, remaining);
	      }
	    }
	  });
	}
	
	function throttle() {
	  for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	    args[_key] = arguments[_key];
	  }
	
	  return (0, _privateUtils.decorate)(handleDescriptor, args);
	}
	
	module.exports = exports['default'];

/***/ }),
/* 25 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	exports['default'] = decorate;
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) arr2[i] = arr[i]; return arr2; } else { return Array.from(arr); } }
	
	function _toArray(arr) { return Array.isArray(arr) ? arr : Array.from(arr); }
	
	var _privateUtils = __webpack_require__(13);
	
	function handleDescriptor(target, key, descriptor, _ref) {
	  var _ref2 = _toArray(_ref);
	
	  var decorator = _ref2[0];
	
	  var args = _ref2.slice(1);
	
	  var configurable = descriptor.configurable;
	  var enumerable = descriptor.enumerable;
	  var writable = descriptor.writable;
	
	  var originalGet = descriptor.get;
	  var originalSet = descriptor.set;
	  var originalValue = descriptor.value;
	  var isGetter = !!originalGet;
	
	  return {
	    configurable: configurable,
	    enumerable: enumerable,
	    get: function get() {
	      var fn = isGetter ? originalGet.call(this) : originalValue;
	      var value = decorator.call.apply(decorator, [this, fn].concat(_toConsumableArray(args)));
	
	      if (isGetter) {
	        return value;
	      } else {
	        var desc = {
	          configurable: configurable,
	          enumerable: enumerable
	        };
	
	        desc.value = value;
	        desc.writable = writable;
	
	        Object.defineProperty(this, key, desc);
	
	        return value;
	      }
	    },
	    set: isGetter ? originalSet : (0, _privateUtils.createDefaultSetter)()
	  };
	}
	
	function decorate() {
	  for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	    args[_key] = arguments[_key];
	  }
	
	  return (0, _privateUtils.decorate)(handleDescriptor, args);
	}
	
	module.exports = exports['default'];

/***/ }),
/* 26 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	exports['default'] = mixin;
	
	var _privateUtils = __webpack_require__(13);
	
	var defineProperty = Object.defineProperty;
	var getPrototypeOf = Object.getPrototypeOf;
	
	function buggySymbol(symbol) {
	  return Object.prototype.toString.call(symbol) === '[object Symbol]' && typeof symbol === 'object';
	}
	
	function hasProperty(prop, obj) {
	  // We have to traverse manually prototypes' chain for polyfilled ES6 Symbols
	  // like "in" operator does.
	  // I.e.: Babel 5 Symbol polyfill stores every created symbol in Object.prototype.
	  // That's why we cannot use construction like "prop in obj" to check, if needed
	  // prop actually exists in given object/prototypes' chain.
	  if (buggySymbol(prop)) {
	    do {
	      if (obj === Object.prototype) {
	        // Polyfill assigns undefined as value for stored symbol key.
	        // We can assume in this special case if there is nothing assigned it doesn't exist.
	        return typeof obj[prop] !== 'undefined';
	      }
	      if (obj.hasOwnProperty(prop)) {
	        return true;
	      }
	    } while (obj = getPrototypeOf(obj));
	    return false;
	  } else {
	    return prop in obj;
	  }
	}
	
	function handleClass(target, mixins) {
	  if (!mixins.length) {
	    throw new SyntaxError('@mixin() class ' + target.name + ' requires at least one mixin as an argument');
	  }
	
	  for (var i = 0, l = mixins.length; i < l; i++) {
	    var descs = (0, _privateUtils.getOwnPropertyDescriptors)(mixins[i]);
	
	    var _iteratorNormalCompletion = true;
	    var _didIteratorError = false;
	    var _iteratorError = undefined;
	
	    try {
	      for (var _iterator = (0, _privateUtils.getOwnKeys)(descs)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
	        var key = _step.value;
	
	        if (!hasProperty(key, target.prototype)) {
	          defineProperty(target.prototype, key, descs[key]);
	        }
	      }
	    } catch (err) {
	      _didIteratorError = true;
	      _iteratorError = err;
	    } finally {
	      try {
	        if (!_iteratorNormalCompletion && _iterator['return']) {
	          _iterator['return']();
	        }
	      } finally {
	        if (_didIteratorError) {
	          throw _iteratorError;
	        }
	      }
	    }
	  }
	}
	
	function mixin() {
	  for (var _len = arguments.length, mixins = Array(_len), _key = 0; _key < _len; _key++) {
	    mixins[_key] = arguments[_key];
	  }
	
	  if (typeof mixins[0] === 'function') {
	    return handleClass(mixins[0], []);
	  } else {
	    return function (target) {
	      return handleClass(target, mixins);
	    };
	  }
	}
	
	module.exports = exports['default'];

/***/ }),
/* 27 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	var _slicedToArray = (function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i['return']) _i['return'](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError('Invalid attempt to destructure non-iterable instance'); } }; })();
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports['default'] = time;
	
	var _privateUtils = __webpack_require__(13);
	
	var labels = {};
	
	// Exported for mocking in tests
	var defaultConsole = {
	  time: console.time ? console.time.bind(console) : function (label) {
	    labels[label] = new Date();
	  },
	  timeEnd: console.timeEnd ? console.timeEnd.bind(console) : function (label) {
	    var timeNow = new Date();
	    var timeTaken = timeNow - labels[label];
	    delete labels[label];
	    console.log(label + ': ' + timeTaken + 'ms');
	  }
	};
	
	exports.defaultConsole = defaultConsole;
	var count = 0;
	
	function handleDescriptor(target, key, descriptor, _ref) {
	  var _ref2 = _slicedToArray(_ref, 2);
	
	  var _ref2$0 = _ref2[0];
	  var prefix = _ref2$0 === undefined ? null : _ref2$0;
	  var _ref2$1 = _ref2[1];
	  var console = _ref2$1 === undefined ? defaultConsole : _ref2$1;
	
	  var fn = descriptor.value;
	
	  if (prefix === null) {
	    prefix = target.constructor.name + '.' + key;
	  }
	
	  if (typeof fn !== 'function') {
	    throw new SyntaxError('@time can only be used on functions, not: ' + fn);
	  }
	
	  return _extends({}, descriptor, {
	    value: function value() {
	      var label = prefix + '-' + count;
	      count++;
	      console.time(label);
	
	      try {
	        return fn.apply(this, arguments);
	      } finally {
	        console.timeEnd(label);
	      }
	    }
	  });
	}
	
	function time() {
	  for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	    args[_key] = arguments[_key];
	  }
	
	  return (0, _privateUtils.decorate)(handleDescriptor, args);
	}

/***/ }),
/* 28 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports['default'] = extendDescriptor;
	
	var _privateUtils = __webpack_require__(13);
	
	function handleDescriptor(target, key, descriptor) {
	  var superKlass = Object.getPrototypeOf(target);
	  var superDesc = Object.getOwnPropertyDescriptor(superKlass, key);
	
	  return _extends({}, superDesc, {
	    value: descriptor.value,
	    initializer: descriptor.initializer,
	    get: descriptor.get || superDesc.get,
	    set: descriptor.set || superDesc.set
	  });
	}
	
	function extendDescriptor() {
	  for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	    args[_key] = arguments[_key];
	  }
	
	  return (0, _privateUtils.decorate)(handleDescriptor, args);
	}
	
	module.exports = exports['default'];

/***/ }),
/* 29 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = applyDecorators;
	var defineProperty = Object.defineProperty;
	var getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
	
	function applyDecorators(Class, props) {
	  var prototype = Class.prototype;
	
	  for (var key in props) {
	    var decorators = props[key];
	
	    for (var i = 0, l = decorators.length; i < l; i++) {
	      var decorator = decorators[i];
	
	      defineProperty(prototype, key, decorator(prototype, key, getOwnPropertyDescriptor(prototype, key)));
	    }
	  }
	
	  return Class;
	}
	
	module.exports = exports["default"];

/***/ }),
/* 30 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	/// <reference path="config.d.ts" />
	Object.defineProperty(exports, "__esModule", { value: true });
	// Get user ID from gProxy-module
	var userId = window.gProxy ? window.gProxy.getToken().UserId : "guest";
	var instId = window.gProxy ? (window.gProxy.getToken().InstId || "") : "";
	// Prepare base URLs depending on current environment
	var env = ("production");
	var userData = '', gas = '', components = '', componentProxy = '', taskPlayer = '';
	switch (env) {
	    case 'production':
	    case 'staging':
	        userData = 'userdata-v2.gyldendal.dk';
	        components = 'komponenter.gyldendal.dk';
	        gas = 'gyldendalaccessservice.gyldendal.dk';
	        componentProxy = 'componentframework.gyldendal.dk';
	        taskPlayer = 'http://opgavegenerator.gyldendal.dk/layouts/layplayer.aspx';
	        break;
	    default:
	        userData = 'test-userdata-v2.gyldendal.dk';
	        components = 'test.komponenter.gyldendal.dk';
	        gas = 'test-gyldendalaccessservice.gyldendal.dk';
	        componentProxy = 'test-componentframework.gyldendal.dk';
	        taskPlayer = 'http://stage2.sl-udv.dk/gyldendal/afvikler-v2.0/';
	        break;
	}
	// Generate configurations
	exports.default = {
	    userId: userId,
	    API: {
	        ekeyUser: "https://" + gas + "/api/User/GetEkeyUserDetailsByEmail?userEmail=%userId%",
	        unicUser: "https://" + gas + "/api/v1/UnicUser/GetPerson?userId=%userId%",
	        checkFavorite: "https://" + userData + "/api/Favorites?userID=" + userId + "&learningObjectID=%id%",
	        addFavorite: "https://" + userData + "/api/Favorites",
	        removeFavorite: "https://" + userData + "/api/Favorites?userID=" + userId + "&learningObjectID=%id%",
	        notebook: "http://" + components + "/notesbog/?userID=" + userId + "&institutionID=" + instId + "&productID=%id%",
	        componentEntry: "https://" + userData + "/api/ComponentEntries/%entryId%",
	        componentProxy: "https://" + componentProxy + "/Proxy/",
	        taskResult: "https://" + userData + "/api/TaskResults/%entryId%",
	        taskPlayer: taskPlayer
	    },
	};


/***/ })
/******/ ]);


// WEBPACK FOOTER //
// gLightbox.js